import axios from '@/axios'
import axiosNative from 'axios'

const config = {
  headers: {
    'Accept-Language': 'us',
    'Content-Type': 'application/json'
  }
}
axiosNative.create(config)

const biometry_api = process.env.VUE_APP_BIOMETRY_URL

// ---------------------------------------------------- Fingerprint
export function getFingerprintInitDevice(dummy) {
  return axiosNative.get(`http://localhost:5678/api/initDevice?dummy=${dummy}/`)
}

export function getFingerprintScannerStatus(dummy, device_handle) {
  return axiosNative.get(`http://localhost:5678/api/getScannerStatus?dummy=${dummy}&sHandle=${device_handle}`)
}

export function getFingerprintStartCapturing(dummy, device_handle) {
  return axiosNative.get(`http://localhost:5678/api/captureSingle?dummy=${dummy}&sHandle=${device_handle}&id=0`)
}

export function getFingerprintTemplateData(dummy, device_handle) {
  return axiosNative.get(`http://localhost:5678/api/getTemplateData?dummy=${dummy}&sHandle=${device_handle}&id=0&encrypt=0&qualityLevel=1&encryptKey&extractEx=0`)
}

export function getFingerprintImageData(dummy, device_handle) {
  return axiosNative.get(`http://localhost:5678/api/getImageData?dummy=${dummy}&sHandle=${device_handle}&id=0&fileType=1&width=288&height=340&compressionRatio=0.1`)
}

export function getFingerprintSetParameters(dummy, device_handle, type) {
  return axiosNative.get(`http://localhost:5678/api/setParameters?dummy=${dummy}&sHandle=${device_handle}&templateType=${type}`)
}

// ---------------------------------------------------- Fingerprint new
export function getNewFingerprintCheckDevice() {
  return axiosNative.get('http://127.0.0.1:11121/rswas/DeviceInfo')
}

export function postNewFingerprintLRT(data) {
  return axios.post('http://127.0.0.1:11121/rswas/Capture', data)
}

export function getNewFingerprintCanvasInfo() {
  return axiosNative.get('http://127.0.0.1:11121/rswas/CanvasInfo')
}

export function postNewFingerprintEnrollmentData(data) {
  return axiosNative.post(`${biometry_api}fingerprints/enrollment/`, data)
}

export function deleteNewFingerprintEnrollmentData(body) {
  return axiosNative.delete(`${biometry_api}fingerprints/destroy/`, { data: body })
}

// ---------------------------------------------------- api
export function login(data) {
  return axios.post('auth/jwt/create/', data)
}

export function getUserTokens(id) {
  return axios.get(`users/token/access/${id}/`)
}

export function postHotelManagementCheckAvailability(data) {
  return axios.post('hotel_management/check-availability/', data)
}

export function getReservationsPaymentPlanHotelsAnalytics() {
  return axios.get('reservations/payment-plan/hotels/analytics/')
}

export function patchReservationsSafariAmendmentRequest(id, data) {
  return axios.patch(`reservations/safari-amendment-request/${id}/`, data)
}

export function patchReservationsSafari(id, data) {
  return axios.patch(`reservations/safari/${id}/`, data)
}

export function getReservationsSafariDriverItinerariesExport(id) {
  return axios.get(`reservations/safari/${id}/driver-itineraries/export/`)
}

export function getReservationsAnalyticsHotelsBednights(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/analytics/hotels-bednights/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getSafariGroupPermits(id) {
  return axios.get(`safari/groups/${id}/permits/`)
}

// ---------------------------------------------------- Common
export function getNavStats() {
  return axios.get('common/nav/stats/')
}

// ---------------------------------------------------- Administrative: Domain Tracker
export function getDomainTracker(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/domains/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postDomain(data) {
  return axios.post('administrative/domains/', data)
}

export function patchDomain(id, data) {
  return axios.patch(`administrative/domains/${id}/`, data)
}

export function getDomainContacts() {
  return axios.get('administrative/domain-contacts/')
}

export function deleteDomain(id) {
  return axios.delete(`administrative/domains/${id}/`)
}

export function getDomainUpdate(id) {
  return axios.get(`administrative/domains/${id}/parse/`)
}

// ---------------------------------------------------- Administrative: Land purchase contact
export function getLandPurchaseContractList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/land-purchase-contract/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postLandPurchaseContract(data) {
  return axios.post('administrative/land-purchase-contract/', data)
}

export function getLandPurchaseContract(id) {
  return axios.get(`administrative/land-purchase-contract/${id}/`)
}

export function patchLandPurchaseContract(id, data) {
  return axios.patch(`administrative/land-purchase-contract/${id}/`, data)
}

export function deleteLandPurchaseContract(id) {
  return axios.delete(`administrative/land-purchase-contract/${id}/`)
}

export function getLandPurchaseContractMap() {
  return axios.get('administrative/land-purchase-contract/map/')
}

// ---------------------------------------------------- Administrative: Legal Entities (Insurance)
export function getAdministrativeLegalEntitiesInsurances(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/legal-entities/${id}/insurances/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postAdministrativeLegalEntitiesInsurance(id, data) {
  return axios.post(`administrative/legal-entities/${id}/insurances/`, data)
}

export function patchAdministrativeLegalEntitiesInsurance(id, insurances_id, data) {
  return axios.patch(`administrative/legal-entities/${id}/insurances/${insurances_id}/`, data)
}

export function deleteAdministrativeLegalEntitiesInsurance(id, insurances_id) {
  return axios.delete(`administrative/legal-entities/${id}/insurances/${insurances_id}/`)
}

// ---------------------------------------------------- Administrative: Legal Entities (Licenses)
export function getAdministrativeLegalEntitiesLicenses(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/legal-entities/${id}/licenses/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postAdministrativeLegalEntitiesLicense(id, data) {
  return axios.post(`administrative/legal-entities/${id}/licenses/`, data)
}

export function patchAdministrativeLegalEntitiesLicense(id, license_id, data) {
  return axios.patch(`administrative/legal-entities/${id}/licenses/${license_id}/`, data)
}

export function deleteAdministrativeLegalEntitiesLicense(id, license_id) {
  return axios.delete(`administrative/legal-entities/${id}/licenses/${license_id}/`)
}

// ---------------------------------------------------- Clients: Groups
export function getClientsGroupsByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/groups/dates/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClientsGroup(data) {
  return axios.post('clients/groups/', data)
}

export function getClientsGroup(id) {
  return axios.get(`clients/groups/${id}/`)
}

export function patchClientsGroup(id, data) {
  return axios.patch(`clients/groups/${id}/`, data)
}

export function deleteClientFromGroup(id, client_id) {
  return axios.delete(`clients/groups/${id}/delete-client/${client_id}/`)
}

export function getClientsGroups(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/groups/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClientsGroupsClientsTransport(id, data) {
  return axios.post(`clients/groups/${id}/clients/arrival-departure/`, data)
}

export function postClientsGroupsChangeManager(id, data) {
  return axios.post(`clients/groups/${id}/change-manager/`, data)
}

export function postClientsGroupsTransferClients(data) {
  return axios.post('clients/groups/transfer-clients/', data)
}

export function patchClientsGroupsPaymentControl(group, data) {
  return axios.patch(`clients/groups/payment-control/${group}/`, data)
}

export function getClientsGroupsPaymentControlByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/groups/payment-control/dates/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Clients: Groups: Export
export function getClientsGroupsExport() {
  return axios.get('clients/exports/groups', { responseType: 'blob' })
}

// ---------------------------------------------------- Clients: FreeDays
export function getClientsFreeDays(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/free-days/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClientsFreeDaysByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/free-days/dates/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClientsFreeDays(data) {
  return axios.post('clients/free-days/', data)
}

export function postClientsToFreeDays(id, data) {
  return axios.post(`clients/free-days/${id}/add-clients/`, data)
}

export function deleteClientsFreeDay(id) {
  return axios.delete(`clients/free-days/${id}/`)
}

export function getClientsFreeDay(id) {
  return axios.get(`clients/free-days/${id}/`)
}

export function patchClientsFreeDay(id, data) {
  return axios.patch(`clients/free-days/${id}/`, data)
}

export function getClientsFreeDayClients(id) {
  return axios.get(`clients/free-days/${id}/clients/`)
}

export function deleteClientsFreeDayClient(id, client_id) {
  return axios.delete(`clients/free-days/${id}/delete-client/${client_id}/`)
}

// ---------------------------------------------------- Clients: Analytics
export function getClientsAnalyticsTourStart(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/analytics/tour-start/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClientsAnalyticsEstimatedIncome(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/analytics/estimated-income/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClientsAnalyticsPersonalInfo(from_date, to_date) {
  return axios.get(`clients/analytics/personal-info/?from_date=${from_date}&to_date=${to_date}`)
}

export function getClientsAnalyticsAdv() {
  return axios.get('clients/analytics/adv/clients/', { responseType: 'blob' })
}

// ---------------------------------------------------- Invoices: Analytics
export function getFinanceAnalyticsEstimatedAccounts(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/analytics/invoices/estimated/accounts/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinanceAnalyticsEstimatedServices(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/analytics/invoices/estimated/services/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinanceAnalyticsPaymentMethods(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/analytics/invoices/paid/methods/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinanceAnalyticsPaymentServices(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/analytics/invoices/paid/services/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Clients: Dicts
export function getClientsTourOperators(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/tour-operators/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClientsTourOperatorManagers(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/tour-operator-managers/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClientsCategories(active) {
  return axios.get(`clients/categories/?active=${active}`)
}

export function getReasonsNoTransfers() {
  return axios.get('dicts/reasons-for-no-transfer/')
}

// ---------------------------------------------------- Clients: Email Notifications
export function getClientsEmailNotifications(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/email-notifications/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Clients: Clients
export function getClients(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getClientsByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/dates/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getClientsLite(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}clients/search/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postClients(data) {
  return axios.post('clients/', data)
}

export function patchClients(id, data) {
  return axios.patch(`clients/${id}/`, data)
}

export function getClient(id) {
  return axios.get(`clients/${id}/`)
}

// ---------------------------------------------------- Leads: Itineraries
export function getLeadsItineraries(id) {
  return axios.get(`leads/${id}/itineraries/`)
}

export function postLeadsItinerary(id, data) {
  return axios.post(`leads/${id}/itineraries/`, data)
}

export function patchLeadsItineraries(id, itinerary_id, data) {
  return axios.patch(`leads/${id}/itineraries/${itinerary_id}/`, data)
}

export function deleteLeadsItineraries(id, itinerary_id) {
  return axios.delete(`leads/${id}/itineraries/${itinerary_id}/`)
}

// ---------------------------------------------------- Leads: Dicts
export function getLeadsSources(active = true) {
  return axios.get(`leads/dicts/sources/?active=${active}`)
}

export function getLeadsStatuses(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/dicts/statuses/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getLeadsAdvSources() {
  return axios.get('leads/dicts/adv-sources/')
}

export function getLeadsStatusReason(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/dicts/status-reasons/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsCommunicationMethods() {
  return axios.get('leads/dicts/communication-methods/?active=true')
}

// ---------------------------------------------------- Leads: Advertising Expenses
export function getLeadsAnalyticsRequestsAdv(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/adv/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getLeadsAdvertisingExpenses(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/advertising/expenses/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postLeadsAdvertisingExpenses(data) {
  return axios.post('leads/advertising/expenses/', data)
}

export function patchLeadsAdvertisingExpenses(id, data) {
  return axios.patch(`leads/advertising/expenses/${id}/`, data)
}

export function deleteLeadsAdvertisingExpenses(id) {
  return axios.delete(`leads/advertising/expenses/${id}/`)
}

// ---------------------------------------------------- Climbing: Groups: Supply
export function getClimbingGroupsSupply(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/supply/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGroupsSupplyDetail(id) {
  return axios.get(`climbing/groups/supply/${id}/`)
}

// ---------------------------------------------------- Climbing: Arrivals: Clients
export function getClimbingGroupsClientsArrivals(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/${id}/clients/arrivals/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingArrivalsClients(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/arrivals/${id}/clients/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Climbing: Arrivals
export function getClimbingArrivals(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/arrivals/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingArrivals(data) {
  return axios.post('climbing/arrivals/', data)
}

export function getClimbingArrivalsDetail(id) {
  return axios.get(`climbing/arrivals/${id}/`)
}

export function deleteClimbingArrivalsDetail(id) {
  return axios.delete(`climbing/arrivals/${id}/`)
}

export function getClimbingArrivalsDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/arrivals/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Leads: Leads
export function getLeads(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postLead(data) {
  return axios.post('leads/', data)
}

export function getLead(id) {
  return axios.get(`leads/${id}/`)
}

export function patchLead(id, data) {
  return axios.patch(`leads/${id}/`, data)
}

export function getLeadsAnalytics(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getRefreshInvoices(id) {
  return axios.get(`leads/${id}/refresh-invoices/`)
}

export function patchAssignToMe(id) {
  return axios.patch(`leads/${id}/assign-to-me/`)
}

export function postDirectLead(data) {
  return axios.post('leads/direct/', data)
}

export function getLeadsUnassigned() {
  return axios.get('leads/unassigned/')
}

export function postLeadsAssigned() {
  return axios.post('leads/assign/')
}

// ---------------------------------------------------- Leads: Communication History
export function postLeadCommunication(id, data) {
  return axios.post(`leads/${id}/communications/`, data)
}
export function getLeadCommunications(id) {
  return axios.get(`leads/${id}/communications/`)
}

export function deleteLeadCommunication(id, communication_id) {
  return axios.delete(`leads/${id}/communications/${communication_id}/`)
}

// ---------------------------------------------------- Leads: Analytics (Sales)
export function getLeadsAnalyticsSalesCount(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/count/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesCountGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/count/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesWeekdaysGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/weekdays/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesHoursGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/hours/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesCountries(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/countries/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesSources(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/sources/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}
export function getLeadsAnalyticsSalesLanguages(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/languages/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesLanguagesGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/languages/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesTourOperators(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/tour-operators/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesRegions(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/regions/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesPreferable(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/preferable-communications/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesDevices(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/devices/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesActivities(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/activities/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesActivitiesGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/activities/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesAssignmentGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/assignment-times/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesConfirmationGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/confirmation-times/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesUrls(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/adv/urls/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesAdvertising(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/adv/source/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesCampaign(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/adv/campaign/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesContent(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/adv/content/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesPersonal(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/managers/personal/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesCurrency(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/currency/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesSourceGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/sources/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsSalesManagersGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/managers/graph/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
    return axios.get(url)
  }
}

// ---------------------------------------------------- Leads: Analytics (Requests)
export function getLeadsAnalyticsRequestsActivities(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/activities/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsActivitiesGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/activities/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsCount(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/count/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsCountGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/count/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsWeekdaysGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/weekdays/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsHoursGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/hours/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsAssignmentGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/assignment-times/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsConfirmationGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/confirmation-times/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsCountries(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/countries/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsSources(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/sources/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsTourOperators(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/tour-operators/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsLanguages(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/languages/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsLanguagesGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/languages/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsManagers(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/managers/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsManagersSummary(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/managers/summary/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsManagersSales(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/managers/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsManagersSummarySales(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/sales/managers/summary/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsAdvertising(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/adv/source/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsCampaign(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/adv/campaign/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsContent(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/adv/content/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsStatusReason(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/status-reason/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsActivitiesClimbing(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/activities/climbing/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsActivitiesSafari(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/activities/safari/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsUrls(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/adv/urls/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsRegions(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/regions/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsPreferable(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/preferable-communications/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsDevices(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/devices/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsMagnets(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/lead-magnets/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestPersonal(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/managers/personal/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsCurrency(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/currency/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsLeadMagnetGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/lead-magnets/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsSourceGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/sources/graph/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsManagersGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/managers/graph/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getLeadsAnalyticsRequestsTerm(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/analytics/requests/adv/term/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

// ---------------------------------------------------- Leads: Export
export function getLeadExport(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/export/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url, { responseType: 'blob' })
}

// ---------------------------------------------------- Leads: Follow Up
export function postLeadFollowUp(id, data) {
  return axios.post(`leads/${id}/follow-up/`, data)
}

export function getLeadFollowUps(id) {
  return axios.get(`leads/${id}/follow-up/`)
}

export function getLeadFollowUpTemplates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/follow-up-templates/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

// ---------------------------------------------------- Leads: Comments
export function postLeadComment(id, data) {
  return axios.post(`leads/${id}/comments/`, data)
}

export function getLeadComments(id) {
  return axios.get(`leads/${id}/comments/`)
}

// ---------------------------------------------------- Leads: Logs
export function getLeadStatusLogs(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/${id}/status-logs/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

// ---------------------------------------------------- Leads: Logs
export function getLeadChangeLogs(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/change-logs/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

// ---------------------------------------------------- Climbing: Groups: Reimbursement
export function getClimbingGroupsReimbursement(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/reimbursement/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchClimbingGroupsReimbursement(id, data) {
  return axios.patch(`climbing/groups/reimbursement/${id}/`, data)
}

export function getClimbingReimbursementList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/reimbursement/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingReimbursement(data) {
  return axios.post('climbing/reimbursement/', data)
}

export function patchClimbingReimbursement(id, data) {
  return axios.patch(`climbing/reimbursement/${id}/`, data)
}

export function getClimbingReimbursement(id) {
  return axios.get(`climbing/reimbursement/${id}/`)
}

export function deleteClimbingReimbursement(id) {
  return axios.delete(`climbing/reimbursement/${id}/`)
}

export function patchClimbingGroupsReimbursementReceived(id, data) {
  return axios.patch(`climbing/reimbursement/${id}/received/`, data)
}

// ---------------------------------------------------- Climbing: Groups
export function getClimbingGroupsBedInTwin(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/${id}/rooms/1-bed-in-twin/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGroupsBedInTwinByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/bed-in-twin/dates/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGroups(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getClimbingGroupsByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/dates/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getClimbingGroupsSearch(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/search/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getClimbingGroupsClients(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/${id}/clients/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGroupsClientsUploads(id) {
  return axios.get(`climbing/groups/${id}/clients/uploads/`)
}

export function getClimbingsGroup(id) {
  return axios.get(`climbing/groups/${id}/`)
}

export function postClimbingsGroups(data) {
  return axios.post('climbing/groups/', data)
}

export function patchClimbingsGroups(id, data) {
  return axios.patch(`climbing/groups/${id}/`, data)
}

export function postClientToClimbingGroup(group_id, data) {
  return axios.post(`climbing/groups/${group_id}/add-clients/`, data)
}

export function deleteClientClimbingGroup(id, client_id) {
  return axios.delete(`climbing/groups/${id}/delete-client/${client_id}/`)
}

export function postClientTransfer(data) {
  return axios.post('climbing/groups/transfer-clients/', data)
}

export function getClimbingGroupFood(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/${id}/clients/food/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchClimbingGroupEditClient(id, data) {
  return axios.patch(`climbing/groups/${id}/edit-clients/`, data)
}

export function getClimbingGroupClientsForNP(id) {
  return axios.get(`climbing/groups/${id}/clients/national-park/`)
}

export function getClimbingGroupPrintInfo(id) {
  return axios.get(`climbing/groups/print-info/${id}/`)
}

export function patchClimbingGroupPrintInfo(id, data) {
  return axios.patch(`climbing/groups/print-info/${id}/`, data)
}

export function getClimbingGroupBirthdays() {
  return axios.get('climbing/groups/clients/birthdays/')
}

// ---------------------------------------------------- Climbing: Join Rooming List

export function getClimbingGroupsJoinRoomingList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/join-rooming-list/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingGroupsJoinRoomingList(data) {
  return axios.post('climbing/join-rooming-list/', data)
}

export function patchClimbingGroupsJoinRoomingList(id, data) {
  return axios.patch(`climbing/join-rooming-list/${id}/`, data)
}

export function deleteClimbingGroupsJoinRoomingList(id) {
  return axios.delete(`climbing/join-rooming-list/${id}/`)
}

// ---------------------------------------------------- Climbing: Group Clients: Edit
export function patchClimbingGroupClients(id, client_id, data) {
  return axios.patch(`climbing/groups/${id}/clients/${client_id}/`, data)
}

// ---------------------------------------------------- Climbing: Group Clients: List
export function getClimbingGroupsClientsHotels(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/${id}/clients/hotels/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Climbing: Checklist
export function getClimbingGroupChecklistExport(group_id, client_id) {
  return axios.get(`climbing/groups/${group_id}/client/${client_id}/checklist/export/`)
}

export function getClimbingGroupChecklistsExport(group_id) {
  return axios.get(`climbing/groups/${group_id}/checklist/export/`)
}

// ---------------------------------------------------- Climbing: Duffle bag tags
export function getClimbingGroupDuffleBagTags(group_id) {
  return axios.get(`climbing/groups/${group_id}/duffle-bag-tags/export/`)
}

// ---------------------------------------------------- Climbing: List for reception
export function getClimbingGroupListOfReception(group_id) {
  return axios.get(`climbing/groups/${group_id}/list-for-reception/export/`)
}

// ---------------------------------------------------- Climbing: GPS Group
export function getClimbingGroupGPS(group_id) {
  return axios.get(`climbing/groups/${group_id}/gps/export/`)
}

// ---------------------------------------------------- Climbing: Visitor registration
export function getClimbingGroupVisitorRegistration(group_id) {
  return axios.get(`climbing/groups/${group_id}/visitor-registration/export/`)
}

// ---------------------------------------------------- Climbing: Voucher
export function getClimbingGroupVoucher(group_id) {
  return axios.get(`climbing/groups/${group_id}/voucher/export/`)
}

// ---------------------------------------------------- Climbing: Luggage tags
export function getClimbingGroupLuggageTags(group_id) {
  return axios.get(`climbing/groups/${group_id}/luggage-tags/export/`)
}

// ---------------------------------------------------- Climbing: Departure form
export function getClimbingGroupDepartureForm(group_id) {
  return axios.get(`climbing/groups/${group_id}/departure-form/export/`)
}

// ---------------------------------------------------- Climbing: arrival form
export function getClimbingGroupArrivalForm(group_id) {
  return axios.get(`climbing/groups/${group_id}/arrival-form/export/`)
}

// ---------------------------------------------------- Climbing: Personal belongings
export function getClimbingGroupPersonalBelongings(group_id) {
  return axios.get(`climbing/groups/${group_id}/personal-belongings/export/`)
}

// ---------------------------------------------------- Climbing: Export
export function getClimbingGroupDocs(group_id) {
  return axios.get(`climbing/groups/${group_id}/clients-documents/export/`, { responseType: 'blob' })
}

export function getClimbingGroupListOfClients(group_id) {
  return axios.get(`climbing/groups/${group_id}/list-of-clients/export/`)
}

export function getClimbingGroupItinerary(group_id) {
  return axios.get(`climbing/groups/${group_id}/climbing-itinerary/export/`)
}

export function getClimbingGroupMedicalCheckUp(group_id) {
  return axios.get(`climbing/groups/${group_id}/medical-check-up/export/`)
}

export function getClimbingGroupPreparationList(group_id) {
  return axios.get(`climbing/groups/${group_id}/preparation-list/export/`)
}

// ---------------------------------------------------- Climbing: Tents
export function getClimbingGroupsTentsAll(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/tents/all/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGroupsTents(id) {
  return axios.get(`climbing/groups/${id}/tents/`)
}

export function postClimbingGroupsTent(id, data) {
  return axios.post(`climbing/groups/${id}/tents/`, data)
}

export function patchClimbingGroupsTent(id, tent_id, data) {
  return axios.patch(`climbing/groups/${id}/tents/${tent_id}/`, data)
}

export function deleteClimbingGroupsTent(id, tent_id) {
  return axios.delete(`climbing/groups/${id}/tents/${tent_id}/`)
}

// ---------------------------------------------------- Climbing: Groups: Equipment items
export function getClimbingGroupsEquipmentItems(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/${id}/equipment-items/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingGroupsEquipmentItems(id, data) {
  return axios.post(`climbing/groups/${id}/equipment-items/`, data)
}

export function patchClimbingGroupsEquipmentItems(id, item_id, data) {
  return axios.patch(`climbing/groups/${id}/equipment-items/${item_id}/`, data)
}

export function deleteClimbingGroupsEquipmentItems(id, item_id) {
  return axios.delete(`climbing/groups/${id}/equipment-items/${item_id}/`)
}

export function getClimbingGroupsCrewPositions(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/${id}/crew-positions/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingGroupsCrewPositions(id, data) {
  return axios.post(`climbing/groups/${id}/crew-positions/`, data)
}

export function patchClimbingGroupsCrewPositions(id, item_id, data) {
  return axios.patch(`climbing/groups/${id}/crew-positions/${item_id}/`, data)
}

export function deleteClimbingGroupsCrewPositions(id, item_id) {
  return axios.delete(`climbing/groups/${id}/crew-positions/${item_id}/`)
}

export function patchClimbingGroupsCalculateEquipment(id) {
  return axios.patch(`climbing/groups/${id}/calculate-equipment/`)
}

export function deleteClimbingGroupsCalculateEquipment(id) {
  return axios.delete(`climbing/groups/${id}/delete-equipment/`)
}

// ---------------------------------------------------- Climbing: Equipment Settings
export function getClimbingEquipmentsSettings(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/equipments/settings/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingEquipmentsSettings(data) {
  return axios.post('climbing/equipments/settings/', data)
}

export function patchClimbingEquipmentsSettings(id, data) {
  return axios.patch(`climbing/equipments/settings/${id}/`, data)
}

export function deleteClimbingEquipmentsSettings(id) {
  return axios.delete(`climbing/equipments/settings/${id}/`)
}

// ---------------------------------------------------- Climbing: Additional services
export function getClimbingOrderService(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/${id}/additional-services/group/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingOrderService(id, data) {
  return axios.post(`climbing/groups/${id}/additional-services/`, data)
}

export function patchClimbingOrderService(id, service_id, data) {
  return axios.patch(`climbing/groups/${id}/additional-services/${service_id}/`, data)
}

export function deleteClimbingOrderService(id, service_id) {
  return axios.delete(`climbing/groups/${id}/additional-services/${service_id}/`)
}

// ---------------------------------------------------- Climbing: Product list
export function getClimbingGroupsProductListTypes() {
  return axios.get('climbing/productlisttype/')
}

export function getClimbingGroupsProducts(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/productlist/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postClimbingGroupsProductList(data) {
  return axios.post('climbing/productlist/', data)
}

// ---------------------------------------------------- Climbing: Dicts
export function getClimbingGroupType() {
  return axios.get('climbing/dicts/group-types/')
}

export function getClimbingRouteCalculation() {
  return axios.get('climbing/dicts/route-calculation-groups/')
}

export function getClimbingMountainCrewPositions() {
  return axios.get('climbing/dicts/mountain-crew/positions/')
}

export function getClimbingAdditionalServiceDict(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/dicts/additional-services/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingRoutes(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/dicts/routes/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGPS(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/dicts/gps/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingMountainCrewRanks() {
  return axios.get('climbing/dicts/mountain-crew/ranks/')
}

export function getClimbingMountainCrewRole() {
  return axios.get('climbing/dicts/mountain-crew/roles/')
}

export function getClimbingCamps(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/dicts/camps/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGPSList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/dicts/gps/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingGPS(data) {
  return axios.post('climbing/dicts/gps/', data)
}

export function patchClimbingGPS(id, data) {
  return axios.patch(`climbing/dicts/gps/${id}/`, data)
}

// ---------------------------------------------------- Climbing: Crew Settings
export function getClimbingCrewSettings(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/crews/settings/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingCrewSettings(data) {
  return axios.post('climbing/crews/settings/', data)
}

export function patchClimbingCrewSettings(id, data) {
  return axios.patch(`climbing/crews/settings/${id}/`, data)
}

export function deleteClimbingCrewSettings(id) {
  return axios.delete(`climbing/crews/settings/${id}/`)
}

// ---------------------------------------------------- Climbing: Analytics
export function getClimbingGroupsServicesUsage(from_date, to_date) {
  return axios.get(`climbing/analytics/services-usage/?from_date=${from_date}&to_date=${to_date}`)
}

export function getClimbingGroupsTentsUsage(from_date, to_date) {
  return axios.get(`climbing/analytics/tents-usage/?from_date=${from_date}&to_date=${to_date}`)
}

export function getClimbingGroupsPeopleOnMountain(from_date, to_date) {
  return axios.get(`climbing/analytics/mountains/?from_date=${from_date}&to_date=${to_date}`)
}

export function getClimbingGroupsClientsAnalytics(from_date, to_date) {
  return axios.get(`climbing/analytics/clients/?from_date=${from_date}&to_date=${to_date}`)
}

export function getClimbingGroupsClientsGateDaysAnalytics(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/analytics/clients/gate/days/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGroupsClientsGateWeekDaysAnalytics(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/analytics/clients/gate/week-days/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingGroupColors(id) {
  return axios.get(`climbing/groups/${id}/info/colors/`)
}

export function getClimbingAnalyticsPersonalInfo(from_date, to_date) {
  return axios.get(`climbing/analytics/personal-info/?from_date=${from_date}&to_date=${to_date}`)
}

// ---------------------------------------------------- Climbing: Special request
export function getClimbingGroupSpecialRequest(group_id) {
  return axios.get(`climbing/groups/${group_id}/special-request/`)
}

export function postClimbingGroupSpecialRequest(group_id, data) {
  return axios.post(`climbing/groups/${group_id}/special-request/`, data)
}

export function patchClimbingGroupSpecialRequest(group_id, special_request_id, data) {
  return axios.patch(`climbing/groups/${group_id}/special-request/${special_request_id}/`, data)
}

export function deleteClimbingGroupSpecialRequest(group_id, special_request_id) {
  return axios.delete(`climbing/groups/${group_id}/special-request/${special_request_id}/`)
}

// ---------------------------------------------------- Climbing: Briefings
export function getClimbingBriefingSchedule(date) {
  return axios.get(`climbing/briefings/schedule/?date=${date}`)
}

export function getClimbingBriefings(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/briefings/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingBriefingsByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/briefings/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingBriefing(id) {
  return axios.get(`climbing/briefings/${id}/`)
}

export function postClimbingBriefing(data) {
  return axios.post('climbing/briefings/', data)
}

export function patchClimbingBriefing(id, data) {
  return axios.patch(`climbing/briefings/${id}/`, data)
}

export function deleteClimbingBriefing(id) {
  return axios.delete(`climbing/briefings/${id}/`)
}

// ---------------------------------------------------- Climbing: Briefings clients
export function getClimbingBriefingClients(id) {
  return axios.get(`climbing/briefings/${id}/clients/`)
}

export function postClimbingBriefingClients(id, data) {
  return axios.post(`climbing/briefings/${id}/clients/`, data)
}

export function getClimbingClientsForBriefings(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/clients/briefings/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingClientsForBriefingsByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/groups/clients/briefings/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function deleteClimbingBriefingClient(id, clients_id) {
  return axios.delete(`climbing/briefings/${id}/clients/${clients_id}/`)
}

// ---------------------------------------------------- Climbing: Mountain crew
export function getClimbingMountainCrewList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/mountain-crews/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingMountainCrewListSearch(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/mountain-crews/search/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getClimbingMountainCrewDetail(id) {
  return axios.get(`climbing/mountain-crews/${id}/`)
}

export function patchClimbingMountainCrew(id, data) {
  return axios.patch(`climbing/mountain-crews/${id}/`, data)
}

// ---------------------------------------------------- Climbing: Mountain crew: Emergency contacts
export function getClimbingMountainCrewEmergencyContacts(id) {
  return axios.get(`climbing/mountain-crews/${id}/emergencycontact/`)
}

export function postClimbingMountainCrewEmergencyContacts(id, data) {
  return axios.post(`climbing/mountain-crews/${id}/emergencycontact/`, data)
}

export function patchClimbingMountainCrewEmergencyContacts(id, contact_id, data) {
  return axios.patch(`climbing/mountain-crews/${id}/emergencycontact/${contact_id}/`, data)
}

export function deleteClimbingMountainCrewEmergencyContacts(id, contact_id) {
  return axios.delete(`climbing/mountain-crews/${id}/emergencycontact/${contact_id}/`)
}

// ---------------------------------------------------- Climbings: Mountain crew (Emergency contact)
export function getClimbingMountainCrewEmergencyList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/mountain-crew/${id}/emergencycontact/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingMountainEmergency(id, data) {
  return axios.post(`climbing/mountain-crew/${id}/emergencycontact/`, data)
}

export function patchClimbingMountainEmergency(id, inline_id, data) {
  return axios.patch(`climbing/mountain-crew/${id}/emergencycontact/${inline_id}/`, data)
}

export function deleteClimbingMountainEmergency(id, inline_id) {
  return axios.delete(`climbing/mountain-crew/${id}/emergencycontact/${inline_id}/`)
}

// ---------------------------------------------------- Climbings: Mountain crew (Covid vaccine)
export function getClimbingMountainCrewCovidList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}climbing/mountain-crew/${id}/covidvaccine/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postClimbingMountainCovid(id, data) {
  return axios.post(`climbing/mountain-crew/${id}/covidvaccine/`, data)
}

export function patchClimbingMountainCovid(id, inline_id, data) {
  return axios.patch(`climbing/mountain-crew/${id}/covidvaccine/${inline_id}/`, data)
}

export function deleteClimbingMountainCovid(id, inline_id) {
  return axios.delete(`climbing/mountain-crew/${id}/covidvaccine/${inline_id}/`)
}

// ---------------------------------------------------- Safari: Groups
export function getSafariGroups(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/groups/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getSafariGroupsByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/groups/dates/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getSafariGroup(id) {
  return axios.get(`safari/groups/${id}/`)
}

export function postSafariGroups(data) {
  return axios.post('safari/groups/', data)
}

export function patchSafariGroups(id, data) {
  return axios.patch(`safari/groups/${id}/`, data)
}

export function deleteClientSafariGroup(id, client_id) {
  return axios.delete(`safari/groups/${id}/clients/${client_id}/`)
}

export function getSafariGroupsClientList(group_id) {
  return axios.get(`safari/groups/${group_id}/clients/`)
}

export function postSafariGroupsClients(group_id, data) {
  return axios.post(`safari/groups/${group_id}/clients/`, data)
}

export function getSafariGroupsSnackBarInfo(group_id) {
  return axios.get(`safari/groups/snack-bar-info/${group_id}/`)
}

export function patchSafariGroupsSnackBarInfo(group_id, data) {
  return axios.patch(`safari/groups/snack-bar-info/${group_id}/`, data)
}

export function getSafariGroupsCarsList(group_id) {
  return axios.get(`safari/groups/${group_id}/cars/`)
}

export function patchSafariGroupsCars(group_id, data) {
  return axios.patch(`safari/groups/${group_id}/cars/`, data)
}

export function getSafariGroupsCarsListByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/groups/cars/dates/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postSafariGroupsReservation(data) {
  return axios.post('safari/groups/reservation/', data)
}

// ---------------------------------------------------- Safari: Analytics
export function getSafariAnalyticsGroups(from_date, to_date) {
  return axios.get(`safari/analytics/groups/?from_date=${from_date}&to_date=${to_date}`)
}

export function getSafariAnalyticsCars(from_date, to_date) {
  return axios.get(`safari/analytics/cars/?from_date=${from_date}&to_date=${to_date}`)
}

export function getSafariAnalyticsSnackBar(from_date, to_date) {
  return axios.get(`safari/analytics/snack-bar/?from_date=${from_date}&to_date=${to_date}`)
}

export function getSafariAnalyticsClients(from_date, to_date) {
  return axios.get(`safari/analytics/clients/?from_date=${from_date}&to_date=${to_date}`)
}

export function getSafariAnalyticsFlyingDoctors(from_date, to_date) {
  return axios.get(`safari/analytics/groups/flying-doctors/?from_date=${from_date}&to_date=${to_date}`)
}

export function getSafariAnalyticsPersonalInfo(from_date, to_date) {
  return axios.get(`safari/analytics/personal-info/?from_date=${from_date}&to_date=${to_date}`)
}

// ---------------------------------------------------- Safari: Export
export function getSafariGroupDocs(group_id) {
  return axios.get(`safari/groups/${group_id}/clients-documents/export/`, { responseType: 'blob' })
}

export function getSafariGroupVouchers(group_id) {
  return axios.get(`safari/groups/${group_id}/hotel-vouchers/export/`, { responseType: 'blob' })
}

export function getSafariGroupListOfClients(group_id) {
  return axios.get(`safari/groups/${group_id}/list-of-clients/export/`)
}

export function getSafariGroupSnackBarExport(id) {
  return axios.get(`safari/groups/${id}/snack_bar/export/`)
}

// ---------------------------------------------------- Safari: Dicts
export function getSafariGroupTypes(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/groups/types/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getSafariCarLevel() {
  return axios.get('safari/safari-car-level/')
}

export function getSafariNationalPark(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/national-park/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getSafariExpenseType() {
  return axios.get('safari/expense-type/')
}

// ---------------------------------------------------- Safari: Own safari car
export function getSafariDoctorsByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/groups/flying-doctors/clients/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchSafariDoctor(id, data) {
  return axios.patch(`safari/groups/flying-doctors/clients/${id}/`, data)
}

// ---------------------------------------------------- Safari: Own safari car
export function getSafariOwnCars(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/own-safari-car/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postSafariOwnCars(data) {
  return axios.post('safari/own-safari-car/', data)
}

// ---------------------------------------------------- Safari: Calendar
export function getSafariScheduleOwn(from_date, to_date) {
  return axios.get(`reservations/safari/schedule/own-cars/?from_date=${from_date}&to_date=${to_date}`)
}

export function getSafariScheduleRental(from_date, to_date) {
  return axios.get(`reservations/safari/schedule/rental-cars/?from_date=${from_date}&to_date=${to_date}`)
}

export function getClimbingGroupsCrewSchedule(from_date, to_date, role) {
  return axios.get(`climbing/groups/crew/schedule/?from_date=${from_date}&to_date=${to_date}&role=${role}`)
}

// ---------------------------------------------------- Safari: Rental Company
export function getSafariRentalCompany(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/rental-company/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getSafariRentalCompanyAvailableCars(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/rental-company/available-cars/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getSafariRentalCompanyCarsDrivers(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/rental-company/cars-drivers/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Safari: Rental car
export function getSafariRentalCars(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/rental-car/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postSafariRentalCars(data) {
  return axios.post('safari/rental-car/', data)
}

export function getSafariRentalCar(id) {
  return axios.get(`safari/rental-car/${id}/`)
}

export function patchSafariCar(id, data) {
  return axios.patch(`safari/rental-car/${id}/`, data)
}

// ---------------------------------------------------- Safari: Driver vaccination
export function getSafariDriverCovidList(id) {
  return axios.get(`safari/driver/${id}/vaccine/`)
}

export function postSafariDriverCovid(id, data) {
  return axios.post(`safari/driver/${id}/vaccine/`, data)
}

export function patchSafariDriverCovid(driver_id, id, data) {
  return axios.patch(`safari/driver/${driver_id}/vaccine/${id}/`, data)
}

export function deleteSafariDriverCovid(driver_id, id) {
  return axios.delete(`safari/driver/${driver_id}/vaccine/${id}/`)
}

// ---------------------------------------------------- Safari: Driver
export function getSafariDrivers(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/driver/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postSafariDriver(data) {
  return axios.post('safari/driver/', data)
}

export function getSafariDriver(id) {
  return axios.get(`safari/driver/${id}/`)
}

export function patchSafariDriver(id, data) {
  return axios.patch(`safari/driver/${id}/`, data)
}

// ---------------------------------------------------- Safari: Car assignment
export function getSafariGroupsCarAssignment(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/group/${id}/car-assignment/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Safari: Cash
export function getSafariGroupsCashList(id) {
  return axios.get(`safari/group/${id}/cash/`)
}

export function postSafariGroupsCash(id, data) {
  return axios.post(`safari/group/${id}/cash/`, data)
}

export function getSafariGroupsCash(groupId, cashId) {
  return axios.get(`safari/group/${groupId}/cash/${cashId}/`)
}

export function patchSafariGroupsCash(groupId, cashId, data) {
  return axios.patch(`safari/group/${groupId}/cash/${cashId}/`, data)
}

// ---------------------------------------------------- Safari: Group expense
export function getSafariGroupsCashExpensesList(id) {
  return axios.get(`safari/cash/${id}/group-expense/`)
}

export function postSafariGroupsCashExpense(id, data) {
  return axios.post(`safari/cash/${id}/group-expense/`, data)
}

export function patchSafariGroupsCashExpense(id, group_expense_id, data) {
  return axios.patch(`safari/cash/${id}/group-expense/${group_expense_id}/`, data)
}

export function deleteSafariGroupsCashExpense(id, group_expense_id) {
  return axios.delete(`safari/cash/${id}/group-expense/${group_expense_id}/`)
}

// ---------------------------------------------------- Safari: Snack bar
export function getSafariSnackBarRequestPrint(id) {
  return axios.get(`snack_bar/request/${id}/export/`)
}

export function getSafariGroupsSnacksList(group_id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}safari/groups/${group_id}/clients/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchSafariSnackBarRequests(id, group_id, data) {
  return axios.patch(`safari/groups/${group_id}/clients/${id}/`, data)
}

// ---------------------------------------------------- Island Vacation: Groups
export function getIslandVacationGroups(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}island-vacation/groups/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getIslandVacationGroupsByDates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}island-vacation/groups/dates/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postIslandVacationGroup(data) {
  return axios.post('island-vacation/groups/', data)
}

export function postIslandVacationClientsToGroup(id, data) {
  return axios.post(`island-vacation/groups/${id}/add-clients/`, data)
}

export function getIslandVacationGroup(id) {
  return axios.get(`island-vacation/groups/${id}/`)
}

export function getIslandVacationGroupClients(id) {
  return axios.get(`island-vacation/groups/${id}/clients/`)
}

export function patchIslandVacationGroup(id, data) {
  return axios.patch(`island-vacation/groups/${id}/`, data)
}

export function deleteIslandVacationGroupClient(id, client_id) {
  return axios.delete(`island-vacation/groups/${id}/delete-client/${client_id}/`)
}

// ---------------------------------------------------- Transfers: Transfers
export function calculateTransferPrice(data) {
  return axios.post('transfers/calculate/', data)
}

export function getTransfersList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getTransfersDatesList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchTransfers(id, data) {
  return axios.patch(`transfers/${id}/`, data)
}

export function deleteTransfer(id) {
  return axios.delete(`transfers/${id}/`)
}

export function postTransferArrival(data) {
  return axios.post('transfers/arrival/', data)
}

export function postTransferDeparture(data) {
  return axios.post('transfers/departure/', data)
}

export function getTransfers(id) {
  return axios.get(`transfers/${id}/`)
}

export function deleteTransfersClient(id, client_id) {
  return axios.delete(`transfers/${id}/del-client/${client_id}/`)
}

export function deleteTransfersEmployee(id, employee_id) {
  return axios.delete(`transfers/${id}/del-employee/${employee_id}/`)
}

export function postTransfersClients(id, data) {
  return axios.post(`transfers/${id}/add-clients/`, data)
}

export function postTransfersStaff(id, data) {
  return axios.post(`transfers/${id}/add-employees/`, data)
}

// ---------------------------------------------------- Transfers: Transfers: Arrivals
export function getTransfersArrivalsDatesList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/transfers-arrivals/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Transfers: Transfers: Creating
export function postTransferClimbing(data) {
  return axios.post('transfers/climbing/', data)
}

export function postTransferArchive(data) {
  return axios.post('transfers/archive/', data)
}

export function postTransferDayTrip(data) {
  return axios.post('transfers/day-trips/', data)
}

export function postTransferStaff(data) {
  return axios.post('transfers/staff/', data)
}

export function postTransferOther(data) {
  return axios.post('transfers/other/', data)
}

export function postTransferSafari(data) {
  return axios.post('transfers/safari/', data)
}

export function postTransferHotelArrival(data) {
  return axios.post('transfers/hotel-arrival/', data)
}

export function postTransferHotelDeparture(data) {
  return axios.post('transfers/hotel-departure/', data)
}

export function postTransferHotelOther(data) {
  return axios.post('transfers/hotel-other/', data)
}

// ---------------------------------------------------- Transfers: Transfers: Editing
export function patchArrivalTransfer(id, data) {
  return axios.patch(`transfers/${id}/arrival/`, data)
}

export function patchDepartureTransfer(id, data) {
  return axios.patch(`transfers/${id}/departure/`, data)
}

export function patchOtherTransfer(id, data) {
  return axios.patch(`transfers/${id}/other/`, data)
}

export function patchStaffTransfer(id, data) {
  return axios.patch(`transfers/${id}/staff/`, data)
}

export function patchClimbingTransfer(id, data) {
  return axios.patch(`transfers/${id}/climbing/`, data)
}

export function patchDayTripTransfer(id, data) {
  return axios.patch(`transfers/${id}/day-trips/`, data)
}

export function patchSafariTransfer(id, data) {
  return axios.patch(`transfers/${id}/safari/`, data)
}

export function patchTransferHotelArrival(id, data) {
  return axios.patch(`transfers/${id}/hotel-arrival/`, data)
}

export function patchTransferHotelDeparture(id, data) {
  return axios.patch(`transfers/${id}/hotel-departure/`, data)
}

export function patchTransferHotelOther(id, data) {
  return axios.patch(`transfers/${id}/hotel-other/`, data)
}

// ---------------------------------------------------- Finance: Pos Transactions

export function patchFinancePosTransactions(id, data) {
  return axios.patch(`finance/pos-transactions/${id}/`, data)
}

export function getFinancePosTransactionsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/pos-transactions/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePosTransactionsUpload(data) {
  return axios.post('finance/pos-transactions/upload/', data)
}

// ---------------------------------------------------- Finance: Export
export function getFinanceAuthDataExport(id) {
  return axios.get(`finance/invoices/${id}/auth-data-export/`)
}

// ---------------------------------------------------- Finance: Invoices
export function getFinanceInvoiceList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/invoices/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchFinanceInvoicePaymentControl(invoice, data) {
  return axios.patch(`finance/invoices/payment-control/${invoice}/`, data)
}

export function patchFinanceInvoiceAuthData(invoice, data) {
  return axios.patch(`finance/invoices/auth-data-charge/${invoice}/`, data)
}

export function deleteFinanceInvoiceAuthData(invoice) {
  return axios.delete(`finance/invoices/auth-data-charge/${invoice}/`)
}

export function patchFinanceInvoicePaymentOnSpot(invoice, data) {
  return axios.patch(`finance/invoices/payment-on-spot/${invoice}/`, data)
}

export function postFinanceInvoiceEFD(id) {
  return axios.post(`finance/invoices/${id}/efd/`)
}

// ---------------------------------------------------- Finance: Quick Payments
export function getFinanceQuickPaymentsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/quick-payments/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Finance: Invoices: EFD
export function postFinanceInvoicesEFD(data) {
  return axios.post('finance/invoices/efd/', data)
}

export function postFinanceCustomSalesEFD(id) {
  return axios.post(`finance/custom-sales/${id}/efd/`)
}

export function postFinanceReimbursementEFD(id) {
  return axios.post(`finance/reimbursement/${id}/efd/`)
}

// ---------------------------------------------------- Finance: Analytics
export function getFinanceAnalyticsAnalyticsEFD(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/analytics/analytics/efd/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Finance: Stats
export function getFinanceAnalyticsStats() {
  return axios.get('finance/analytics/stats/')
}

// ---------------------------------------------------- Finance: dicts
export function getFinancePaymentMethods(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/dicts/payment-methods/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePaymentsUTTSalaries(data) {
  return axios.post('finance/payments/utt-salaries/', data)
}

export function getFinanceFundRequestsMeasurements() {
  return axios.get('finance/dicts/fund-requests/measurements/')
}

export function getFinanceMobileMoneyProviders() {
  return axios.get('finance/dicts/mobile-money-providers/')
}

export function getFinancePosTransactionsSource() {
  return axios.get('finance/dicts/pos-transaction-sources/')
}

export function getFinanceTaxZones() {
  return axios.get('finance/dicts/tax-zones/')
}

export function getFinanceInvoicePaymentMethods() {
  return axios.get('finance/dicts/invoice-payment-methods/')
}

export function getFinanceTaxStatuses() {
  return axios.get('finance/dicts/tax-statuses/')
}

// ---------------------------------------------------- Finance: Banks
export function getFinanceBanks(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/dicts/banks/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceBank(data) {
  return axios.post('finance/dicts/banks/', data)
}

export function patchFinanceBank(id, data) {
  return axios.patch(`finance/dicts/banks/${id}/`, data)
}

export function deleteFinanceBank(id) {
  return axios.delete(`finance/dicts/banks/${id}/`)
}

export function getCardTypes() {
  return axios.get('finance/dicts/credit-card-types/')
}

// ---------------------------------------------------- Finance: Transaction Items
export function getFinanceTransactionsItemsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/dicts/transactions/items/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceTransactionsItem(data) {
  return axios.post('finance/dicts/transactions/items/', data)
}

export function patchFinanceTransactionsItem(id, data) {
  return axios.patch(`finance/dicts/transactions/items/${id}/`, data)
}

export function deleteFinanceTransactionsItem(id) {
  return axios.delete(`finance/dicts/transactions/items/${id}/`)
}

// ---------------------------------------------------- Finance: Transaction Item Groups
export function getFinanceTransactionsItemGroupsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/dicts/transactions/item-groups/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceTransactionsItemGroup(data) {
  return axios.post('finance/dicts/transactions/item-groups/', data)
}

export function patchFinanceTransactionsItemGroup(id, data) {
  return axios.patch(`finance/dicts/transactions/item-groups/${id}/`, data)
}

export function deleteFinanceTransactionsItemGroup(id) {
  return axios.delete(`finance/dicts/transactions/item-groups/${id}/`)
}

// ---------------------------------------------------- Finance: Fund requests
export function getFinanceFundRequests(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/fund-requests/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceFundRequests(data) {
  return axios.post('finance/fund-requests/', data)
}

export function getFinanceFundRequest(id) {
  return axios.get(`finance/fund-requests/${id}/`)
}

export function patchFinanceFundRequests(id, data) {
  return axios.patch(`finance/fund-requests/${id}/`, data)
}

export function deleteFinanceFundRequests(id) {
  return axios.delete(`finance/fund-requests/${id}/`)
}

// ---------------------------------------------------- Finance: Taxes
export function getFinanceTaxesList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/taxes/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceTaxes(data) {
  return axios.post('finance/taxes/', data)
}

export function getFinanceTaxes(id) {
  return axios.get(`finance/taxes/${id}/`)
}

export function patchFinanceTaxes(id, data) {
  return axios.patch(`finance/taxes/${id}/`, data)
}

export function deleteFinanceTaxes(id) {
  return axios.delete(`finance/taxes/${id}/`)
}

export function postFinanceTaxesInvoice(id, data) {
  return axios.post(`finance/taxes/${id}/invoice/`, data)
}

// ---------------------------------------------------- Finance: VAT Statements
export function getFinanceVatStatementsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/vat-statements/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceVatStatements(data) {
  return axios.post('finance/vat-statements/', data)
}

export function getFinanceVatStatements(id) {
  return axios.get(`finance/vat-statements/${id}/`)
}

export function patchFinanceVatStatements(id, data) {
  return axios.patch(`finance/vat-statements/${id}/`, data)
}

export function postFinanceVatStatementsRefresh(vat_id) {
  return axios.post(`finance/vat-statements/${vat_id}/refresh/`)
}

// ---------------------------------------------------- Finance: VAT Statements: File & Records
export function postFinanceVatStatementsFile(id, data) {
  return axios.post(`finance/vat-statements/${id}/files/`, data)
}

export function getFinanceVatStatementsFileList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/vat-statements/${id}/files/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinanceVatStatementsRecordsList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/vat-statements/${id}/records/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Finance: Fund request items
export function getFinanceFundRequestsItems(id) {
  return axios.get(`finance/fund-requests/${id}/items/`)
}

export function postFinanceFundRequestsItems(id, data) {
  return axios.post(`finance/fund-requests/${id}/items/`, data)
}

export function patchFinanceFundRequestsItems(id, item_id, data) {
  return axios.patch(`finance/fund-requests/${id}/items/${item_id}/`, data)
}

export function deleteFinanceFundRequestsItems(id, item_id) {
  return axios.delete(`finance/fund-requests/${id}/items/${item_id}/`)
}

export function postFinanceFundRequestsEfdReceipts(id, data) {
  return axios.post(`finance/fund-requests/${id}/efd-receipts/`, data)
}

// ---------------------------------------------------- Finance: EFD Receipts
export function getFinanceSuppliersEFDReceipts(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/suppliers/efd-receipts/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinanceEFDReceiptsZReports(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/efd-receipts/z-reports/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinanceEFDReceiptsZReportsSummary(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/efd-receipts/z-reports-summary/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceEFDReceipt(data) {
  return axios.post('finance/suppliers/efd-receipts/', data)
}

export function patchFinanceEFDReceipt(id, data) {
  return axios.patch(`finance/suppliers/efd-receipts/${id}/`, data)
}

export function deleteFinanceEFDReceipt(id) {
  return axios.delete(`finance/suppliers/efd-receipts/${id}/`)
}

// ---------------------------------------------------- Finance: EFD Receipts
export function getFinanceEFDReceipts(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/efd-receipts/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Finance: Payments
export function getFinancePaymentsTransfersTaxi(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/transfers/taxi/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePaymentsTransfersTaxi(data) {
  return axios.post('finance/payments/transfers/taxi/', data)
}

export function getFinancePaymentsTransfersRental(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/transfers/rental/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePaymentsTransfersRental(data) {
  return axios.post('finance/payments/transfers/rental/', data)
}

// ---------------------------------------------------- Finance: On site Payment
export function getFinancePaymentsOnSiteList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/on-site/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinancePaymentsOnSite(id) {
  return axios.get(`finance/payments/on-site/${id}/`)
}

export function postFinancePaymentsOnSiteComplete(id) {
  return axios.post(`finance/payments/on-site/${id}/complete/`)
}

export function postFinancePaymentsOnSitePos(id, data) {
  return axios.post(`finance/payments/on-site/${id}/pos-transaction/`, data)
}

export function deleteFinancePaymentsOnSitePos(id, transaction_id) {
  return axios.delete(`finance/payments/on-site/${id}/pos-transaction/${transaction_id}/`)
}

// ---------------------------------------------------- Finance: On site Payment: Inlines: Cash
export function getFinancePaymentsOnSiteCashList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/on-site/${id}/cash-payments/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePaymentsOnSiteCash(id, data) {
  return axios.post(`finance/payments/on-site/${id}/cash-payments/`, data)
}

export function patchFinancePaymentsOnSiteCash(id, item_id, data) {
  return axios.patch(`finance/payments/on-site/${id}/cash-payments/${item_id}/`, data)
}

export function deleteFinancePaymentsOnSiteCash(id, item_id) {
  return axios.delete(`finance/payments/on-site/${id}/cash-payments/${item_id}/`)
}

export function patchFinancePaymentsOnSiteCashCashflow(id, item_id, data) {
  return axios.patch(`finance/payments/on-site/${id}/cash-payments/${item_id}/cashflow/`, data)
}

// ---------------------------------------------------- Finance: On site Payment: Inlines: Gear
export function getFinancePaymentsOnSiteGearList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/on-site/${id}/gears/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePaymentsOnSiteGear(id, data) {
  return axios.post(`finance/payments/on-site/${id}/gears/`, data)
}

export function patchFinancePaymentsOnSiteGear(id, item_id, data) {
  return axios.patch(`finance/payments/on-site/${id}/gears/${item_id}/`, data)
}

export function deleteFinancePaymentsOnSiteGear(id, item_id) {
  return axios.delete(`finance/payments/on-site/${id}/gears/${item_id}/`)
}

export function getFinancePaymentsOnSiteGears(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/on-site/gears/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Finance: On site Payment: Inlines: Additional Services
export function getFinancePaymentsOnSiteAdditionalList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/on-site/${id}/additional-services/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePaymentsOnSiteAdditional(id, data) {
  return axios.post(`finance/payments/on-site/${id}/additional-services/`, data)
}

export function patchFinancePaymentsOnSiteAdditional(id, item_id, data) {
  return axios.patch(`finance/payments/on-site/${id}/additional-services/${item_id}/`, data)
}

export function deleteFinancePaymentsOnSiteAdditional(id, item_id) {
  return axios.delete(`finance/payments/on-site/${id}/additional-services/${item_id}/`)
}

// ---------------------------------------------------- Finance: On site Payment: Inlines: Other
export function getFinancePaymentsOnSiteOtherList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/on-site/${id}/other/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePaymentsOnSiteOther(id, data) {
  return axios.post(`finance/payments/on-site/${id}/other/`, data)
}

export function patchFinancePaymentsOnSiteOther(id, item_id, data) {
  return axios.patch(`finance/payments/on-site/${id}/other/${item_id}/`, data)
}

export function deleteFinancePaymentsOnSiteOther(id, item_id) {
  return axios.delete(`finance/payments/on-site/${id}/other/${item_id}/`)
}

// ---------------------------------------------------- Finance: Payment Plan
export function getFinancePaymentsPaymentPlanList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/payment-plan/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinancePaymentsPaymentPlanGroupingList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/payments/payment-plan/grouping/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getFinanceSupplierInvoicePaymentPlanList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/supplier-invoice/payment-plan/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }

  return axios.get(url)
}

// ---------------------------------------------------- Finance: Accounts
export function getFinanceAccounts(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/accounts/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceAccountsBalanceReconciliation(data) {
  return axios.post('finance/accounts/balance-reconciliation/', data)
}

// ---------------------------------------------------- Finance: Pos Transactions: Reconciliations
export function getFinancePosTransactionsImports(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/pos-transactions/reconciliation-files/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })

  return axios.get(url)
}

export function postFinancePosTransactionsImports(data) {
  return axios.post('finance/pos-transactions/reconciliation-files/', data)
}

export function deleteFinancePosTransactionsImports(id) {
  return axios.delete(`finance/pos-transactions/reconciliation-files/${id}/`)
}

export function getFinancePosTransactionsImportsDetail(id) {
  return axios.get(`finance/pos-transactions/reconciliation-files/${id}/`)
}

export function getFinancePosTransactionsImportsDetailItems(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/pos-transactions/reconciliation-files/${id}/items/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinancePosTransactionsImportsDetailItemsRecalculateAll(id) {
  return axios.post(`finance/pos-transactions/reconciliation-files/${id}/items/recalculate-all/`)
}

// ---------------------------------------------------- Finance: Cashflow Reconciliation
export function getFinanceCashflowReconciliation(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/cashflow/reconciliation/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })

  return axios.get(url)
}

export function patchFinanceCashflowReconciliation(id, data) {
  return axios.patch(`finance/cashflow/reconciliation/${id}/`, data)
}

export function patchFinanceCashflowReconciliationTransactions(id, data) {
  return axios.patch(`finance/cashflow/reconciliation/${id}/transaction/`, data)
}

export function patchFinanceCashflowReconciliationSync() {
  return axios.patch('finance/cashflow/reconciliation/sync/')
}

export function getFinanceCashflowReconciliationAccountFiles(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/cashflow/reconciliation/account-files/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })

  return axios.get(url)
}

export function postFinanceCashflowReconciliationAccountFiles(data) {
  return axios.post('finance/cashflow/reconciliation/account-files/', data)
}

export function postFinanceCashflowReconciliationTransactions(data) {
  return axios.post('finance/cashflow/reconciliation/transactions/', data)
}

// ---------------------------------------------------- Finance: Cashflow
export function getFinanceCashflow(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/cashflow/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })

  return axios.get(url)
}

export function getFinanceCashflowSearch(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/cashflow/search/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })

  return axios.get(url)
}

export function postFinanceCashflow(data) {
  return axios.post('finance/cashflow/', data)
}

export function postFinanceCashflowTransfer(data) {
  return axios.post('finance/cashflow/transfer/', data)
}

export function patchFinanceCashflow(id, data) {
  return axios.patch(`finance/cashflow/${id}/`, data)
}

export function putFinanceCashflowTransfer(transfer_id, data) {
  return axios.put(`finance/cashflow/transfer/${transfer_id}/`, data)
}

export function deleteFinanceCashflow(id) {
  return axios.delete(`finance/cashflow/${id}/`)
}

export function deleteFinanceCashflowTransfer(transfer_id) {
  return axios.delete(`finance/cashflow/transfer/${transfer_id}/`)
}

export function postFinanceCashflowReceptionOutcome(data) {
  return axios.post('finance/cashflow/reception-outcome/', data)
}

// ---------------------------------------------------- Finance: Supplier Invoices
export function getFinanceSupplierInvoiceList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/supplier-invoice/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }

  return axios.get(url)
}

export function postFinanceSupplierInvoice(data) {
  return axios.post('finance/supplier-invoice/', data)
}

export function patchFinanceSupplierInvoice(id, data) {
  return axios.patch(`finance/supplier-invoice/${id}/`, data)
}

// ---------------------------------------------------- Finance: Custom Sale
export function getFinanceCustomSaleList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/custom-sales/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postFinanceCustomSale(data) {
  return axios.post('finance/custom-sales/', data)
}

export function patchFinanceCustomSale(id, data) {
  return axios.patch(`finance/custom-sales/${id}/`, data)
}

export function deleteFinanceCustomSale(id) {
  return axios.delete(`finance/custom-sales/${id}/`)
}

// ---------------------------------------------------- Finance: Fund request: Supplier Invoices
export function getFinanceFundRequestsSupplierInvoiceList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/fund-requests/${id}/supplier-invoice/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }

  return axios.get(url)
}

export function deleteFinanceFundRequestsSupplierInvoice(id, invoice_id) {
  return axios.delete(`finance/fund-requests/${id}/supplier-invoice/${invoice_id}/`)
}

// ---------------------------------------------------- Finance: Cashflow: Fund request
export function postFinanceFundRequestsSupplierInvoice(id, data) {
  return axios.post(`finance/fund-requests/${id}/supplier-invoice/`, data)
}

// ---------------------------------------------------- Finance: Cashflow: Fund request
export function getFinanceFundRequestsCashflowList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}finance/fund-requests/${id}/cashflow/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }

  return axios.get(url)
}

export function postFinanceFundRequestsCashflow(id, data) {
  return axios.post(`finance/fund-requests/${id}/cashflow/`, data)
}

export function deleteFinanceFundRequestsCashflow(id, cashflow_id) {
  return axios.delete(`finance/fund-requests/${id}/cashflow/${cashflow_id}/`)
}

export function patchFinanceFundRequestsCashflow(id, cashflow_id, data) {
  return axios.patch(`finance/fund-requests/${id}/cashflow/${cashflow_id}/`, data)
}

// ---------------------------------------------------- Transfers: Signboard export
export function getTransferSignboardPrint(id) {
  return axios.get(`transfers/${id}/signboard/export/`)
}

// ---------------------------------------------------- Transfers: Export
export function postTransfersWLExport(id, data) {
  return axios.post(`transfers/${id}/wl/export/`, data)
}

// ---------------------------------------------------- Signboard: Single signboard export
export function postTransferSingleSignboardPrint(export_type, text) {
  if (export_type === 'print') return axios.post(`signboard/export/?export_type=${export_type}`, text)
  else return axios.post(`signboard/export/?export_type=${export_type}`, text, { responseType: 'blob' })
}

// ---------------------------------------------------- Transfer: Analytics
export function getTransferAnalytics(from_date, to_date) {
  return axios.get(`transfers/analytics/car-models/?from_date=${from_date}&to_date=${to_date}`)
}

// ---------------------------------------------------- Transfers: Transfers (Own cars)
export function getTransfersOwnCarsSelect(id) {
  return axios.get(`transfers/${id}/own-cars/select/`)
}

export function postTransfersOwnCars(id, data) {
  return axios.post(`transfers/${id}/own-cars/`, data)
}

export function patchTransfersOwnCars(id, car_id, data) {
  return axios.patch(`transfers/${id}/own-cars/${car_id}/`, data)
}

export function deleteTransfersOwnCars(id, car_id) {
  return axios.delete(`transfers/${id}/own-cars/${car_id}/`)
}

export function getOwnCarsSchedule(date) {
  return axios.get(`transfers/schedule/own-cars/?date=${date}`)
}

export function getRentalCarsSchedule(date) {
  return axios.get(`transfers/schedule/rental-cars/?date=${date}`)
}

export function getTaxiSchedule(date) {
  return axios.get(`transfers/schedule/taxi/?date=${date}`)
}

// ---------------------------------------------------- Transfers: Transfers (Rental cars)
export function getTransfersRentalCars(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/${id}/rental-cars/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postTransfersRentalCar(id, data) {
  return axios.post(`transfers/${id}/rental-cars/`, data)
}

export function deleteTransfersRentalCars(id, car_id) {
  return axios.delete(`transfers/${id}/rental-cars/${car_id}/`)
}

export function patchTransfersRentalCars(id, car_id, data) {
  return axios.patch(`transfers/${id}/rental-cars/${car_id}/`, data)
}

// ---------------------------------------------------- Transfers: Transfers (Points)
export function getTransfersPoints(id) {
  return axios.get(`transfers/${id}/point/`)
}

export function postTransfersPoint(id, data) {
  return axios.post(`transfers/${id}/point/`, data)
}

export function patchTransfersPoint(id, point_id, data) {
  return axios.patch(`transfers/${id}/point/${point_id}/`, data)
}

export function deleteTransfersPoint(id, point_id) {
  return axios.delete(`transfers/${id}/point/${point_id}/`)
}

// ---------------------------------------------------- Transfers: Transfers (Taxi drivers)
export function getTransfersTaxiList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/${id}/taxi/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postTransfersTaxi(id, data) {
  return axios.post(`transfers/${id}/taxi/`, data)
}

export function patchTransfersTaxi(id, taxi_id, data) {
  return axios.patch(`transfers/${id}/taxi/${taxi_id}/`, data)
}

export function deleteTransfersTaxi(id, taxi_id) {
  return axios.delete(`transfers/${id}/taxi/${taxi_id}/`)
}

// ---------------------------------------------------- Transfers: Taxi driver invoices
export function getTransfersTaxiDriversInvoices(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/taxi/drivers/${id}/invoices/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postTransfersTaxiDriversInvoices(id, data) {
  return axios.post(`transfers/taxi/drivers/${id}/invoices/`, data)
}

export function deleteTransfersTaxiDriversInvoices(id, invoice_id) {
  return axios.delete(`transfers/taxi/drivers/${id}/invoices/${invoice_id}/`)
}

// ---------------------------------------------------- Transfers: Rental company invoices
export function getTransfersRentalCompaniesInvoices(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/rental-companies/${id}/invoices/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postTransfersRentalCompaniesInvoices(id, data) {
  return axios.post(`transfers/rental-companies/${id}/invoices/`, data)
}

export function deleteTransfersRentalCompaniesInvoices(id, invoice_id) {
  return axios.delete(`transfers/rental-companies/${id}/invoices/${invoice_id}/`)
}

// ---------------------------------------------------- Transfers: Taxi drivers
export function getTransfersTaxiDriversList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/taxi/drivers/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postTransfersTaxiDrivers(data) {
  return axios.post('transfers/taxi/drivers/', data)
}

export function getTransfersTaxiDrivers(id) {
  return axios.get(`transfers/taxi/drivers/${id}/`)
}

export function patchTransfersTaxiDrivers(id, data) {
  return axios.patch(`transfers/taxi/drivers/${id}/`, data)
}

// ---------------------------------------------------- Transfers: Rental company
export function getTransfersRentalCompanyList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/rental-companies/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postTransfersRentalCompany(data) {
  return axios.post('transfers/rental-companies/', data)
}

export function getTransfersRentalCompany(id) {
  return axios.get(`transfers/rental-companies/${id}/`)
}

export function patchTransfersRentalCompany(id, data) {
  return axios.patch(`transfers/rental-companies/${id}/`, data)
}

// ---------------------------------------------------- Transfers: Rental company (Drivers)
export function getTransfersRentalCompanyDriversList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/rental-companies/${id}/drivers/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postTransfersRentalCompanyDrivers(id, data) {
  return axios.post(`transfers/rental-companies/${id}/drivers/`, data)
}

export function patchTransfersRentalCompanyDrivers(id, driver_id, data) {
  return axios.patch(`transfers/rental-companies/${id}/drivers/${driver_id}/`, data)
}

export function deleteTransfersRentalCompanyDrivers(id, driver_id) {
  return axios.delete(`transfers/rental-companies/${id}/drivers/${driver_id}/`)
}

// ---------------------------------------------------- Transfers: Rental company (Cars)
export function getTransfersRentalCompanyCarsList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/rental-companies/${id}/cars/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postTransfersRentalCompanyCars(id, data) {
  return axios.post(`transfers/rental-companies/${id}/cars/`, data)
}

export function patchTransfersRentalCompanyCars(id, car_id, data) {
  return axios.patch(`transfers/rental-companies/${id}/cars/${car_id}/`, data)
}

// ---------------------------------------------------- Transfers: Transfer cars
export function getTransfersRentalCarsNew(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/rental-cars/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getTransfersTaxi(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/taxi/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

// ---------------------------------------------------- Transfers: Fast Tracks
export function getTransfersFastTrackList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}transfers/fast_tracks/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postTransfersFastTrack(data) {
  return axios.post('transfers/fast_tracks/', data)
}

export function getTransfersFastTrack(id) {
  return axios.get(`transfers/fast_tracks/${id}/`)
}

export function patchTransfersFastTrack(id, data) {
  return axios.patch(`transfers/fast_tracks/${id}/`, data)
}

// ---------------------------------------------------- Equipment storage: Rental items
export function getEquipmentStorageItemRentals(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}equipmentstorage/rentalitem/${id}/rentals/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

// ---------------------------------------------------- Equipment storage: Items
export function getEquipmentStorageItems(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}equipmentstorage/item/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postEquipmentStorageItem(data) {
  return axios.post('equipmentstorage/item/', data)
}

export function getEquipmentStorageItem(id) {
  return axios.get(`equipmentstorage/item/${id}/`)
}

export function patchEquipmentStorageItem(id, data) {
  return axios.patch(`equipmentstorage/item/${id}/`, data)
}

// ---------------------------------------------------- Equipment storage: Export
export function getRentalPrint(id) {
  return axios.get(`equipmentstorage/rental/${id}/export/`)
}

// ---------------------------------------------------- Equipment storage: Dicts
export function getEquipmentStorageCategory() {
  return axios.get('equipmentstorage/category/?active=true')
}

export function getEquipmentStorageBrand() {
  return axios.get('equipmentstorage/brand/?active=true')
}

export function getEquipmentStorageColor() {
  return axios.get('equipmentstorage/color/?active=true')
}

export function getEquipmentStorageSize() {
  return axios.get('equipmentstorage/size/?active=true')
}

export function getRentalItemsStatus() {
  return axios.get('equipmentstorage/rentalitemstatus/')
}

// ---------------------------------------------------- Equipment storage: Rentals
export function getRentals(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}equipmentstorage/rental/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function postRental(data) {
  return axios.post('equipmentstorage/rental/', data)
}

export function getRental(id) {
  return axios.get(`equipmentstorage/rental/${id}/`)
}

export function deleteRental(id) {
  return axios.delete(`equipmentstorage/rental/${id}/`)
}

export function patchRental(id, data) {
  return axios.patch(`equipmentstorage/rental/${id}/`, data)
}

export function postRentalPayment(rental_id, data) {
  return axios.post(`equipmentstorage/${rental_id}/rentalpayments/`, data)
}

// ---------------------------------------------------- Equipment storage: Purchase items
export function getEquipmentStoragePurchaseItems(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}equipmentstorage/purchaseitem/`)
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function putEquipmentStoragePurchaseItems(id, data) {
  return axios.put(`equipmentstorage/purchaseitem/${id}/`, data)
}

// ---------------------------------------------------- Equipment storage: Rentals (Rental items list)
export function postRentalItems(id, data) {
  return axios.post(`equipmentstorage/${id}/rentalitemslist/`, data)
}

export function getRentalItems(id) {
  return axios.get(`equipmentstorage/${id}/rentalitemslist/`)
}

export function deleteRentalItem(rental_id, id) {
  return axios.delete(`equipmentstorage/${rental_id}/rentalitemslist/${id}/`)
}

export function patchRentalItem(rental_id, id, data) {
  return axios.patch(`equipmentstorage/${rental_id}/rentalitemslist/${id}/`, data)
}

export function getRentalItemsWithout(id) {
  return axios.get(`equipmentstorage/${id}/rentalcategorylist/`)
}

export function postRentalItemsWithout(id, data) {
  return axios.post(`equipmentstorage/${id}/rentalcategorylist/`, data)
}

export function patchRentalItemWithout(rental_id, id, data) {
  return axios.patch(`equipmentstorage/${rental_id}/rentalcategorylist/${id}/`, data)
}

export function deleteRentalItemWithout(rental_id, id) {
  return axios.delete(`equipmentstorage/${rental_id}/rentalcategorylist/${id}/`)
}

// ---------------------------------------------------- Equipment storage: Rentals (Purchase items list)
export function getPurchaseItems(id) {
  return axios.get(`equipmentstorage/${id}/purchaseitemslist/`)
}

export function postPurchaseItems(id, data) {
  return axios.post(`equipmentstorage/${id}/purchaseitemslist/`, data)
}

export function deletePurchaseItem(rental_id, id) {
  return axios.delete(`equipmentstorage/${rental_id}/purchaseitemslist/${id}/`)
}

export function patchPurchaseItem(rental_id, id, data) {
  return axios.patch(`equipmentstorage/${rental_id}/purchaseitemslist/${id}/`, data)
}

// ---------------------------------------------------- Equipment storage: Stocktakings
export function getEquipmentStorageStocktakings(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}equipmentstorage/stocktaking/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function getEquipmentStorageStocktaking(id) {
  return axios.get(`equipmentstorage/stocktaking/${id}/`)
}

export function postEquipmentStorageStocktaking(data) {
  return axios.post('equipmentstorage/stocktaking/', data)
}

export function patchEquipmentStorageStocktaking(id, data) {
  return axios.patch(`equipmentstorage/stocktaking/${id}/`, data)
}

export function deleteEquipmentStorageStocktaking(id) {
  return axios.delete(`equipmentstorage/stocktaking/${id}/`)
}

// ---------------------------------------------------- Equipment storage: Stocktakings (Rental items list)
export function getEquipmentStorageStocktakingItems(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}equipmentstorage/stocktaking/${id}/items/`)

  Object.entries(params).forEach(([key, value]) => {
    if (value || value === false) url.searchParams.append(key, value)
  })
  return axios.get(url)
}

export function patchEquipmentStorageStocktakingItem(id, item_id, data) {
  return axios.patch(`equipmentstorage/stocktaking/${id}/items/${item_id}/`, data)
}

// ---------------------------------------------------- Employees: Employees (Biometry)
export function postEmployeesFingerprints(id, data) {
  return axios.post(`employees/${id}/fingerprints/`, data)
}

export function postEmployeesFingerprintsVerify(data) {
  return axiosNative.post(`${biometry_api}fingerprints/verify/`, data)
}

export function postEmployeesFingerprintsIdentify(data) {
  return axiosNative.post(`${biometry_api}fingerprints/identify/`, data)
}

export function getEmployeesFingerprintsList(id) {
  return axios.get(`employees/${id}/fingerprints/`)
}

// ---------------------------------------------------- Employees: Payments
export function getEmployeesUTTBalance(from_date, to_date) {
  return axios.get(`employees/utt/balance/?from_date=${from_date}&to_date=${to_date}`)
}

// ---------------------------------------------------- Employees: Payments
export function getEmployeesAnalyticsPositions() {
  return axios.get('employees/analytics/positions/')
}

export function getEmployeesAnalyticsCompanies() {
  return axios.get('employees/analytics/companies/')
}

export function getEmployeesAnalyticsDepartments() {
  return axios.get('employees/analytics/departments/')
}

export function getEmployeesAnalyticsCompensationTZS(from_date, to_date) {
  return axios.get(`employees/analytics/compensation/tzs/?from_date=${from_date}&to_date=${to_date}`)
}

export function getEmployeesAnalyticsCompensationAdvances(from_date, to_date) {
  return axios.get(`employees/analytics/compensation/advances/?from_date=${from_date}&to_date=${to_date}`)
}

// ---------------------------------------------------- Employees: Export
export function getEmployeesExportPAYE(id) {
  return axios.get(`employees/payroll/${id}/export/paye/`, { responseType: 'blob' })
}

export function getEmployeesExportNSSF(id) {
  return axios.get(`employees/payroll/${id}/export/nssf/`, { responseType: 'blob' })
}

export function getEmployeesExportNHIF(id) {
  return axios.get(`employees/payroll/${id}/export/nhif/`, { responseType: 'blob' })
}

export function getEmployeesExportNMB(id) {
  return axios.get(`employees/payroll/${id}/export/nmb/`, { responseType: 'blob' })
}

export function getEmployeesExportGeneral(id) {
  return axios.get(`employees/payroll/${id}/export/general/`, { responseType: 'blob' })
}

export function getEmployeesExportPaymentSlip(id) {
  return axios.get(`employees/payroll/employees/${id}/export/payment-slip/`)
}

// ---------------------------------------------------- Employees: Dicts
export function getEmployeesDepartmentList() {
  return axios.get('employees/department/')
}

export function getEmployeesPositionList() {
  return axios.get('employees/position/')
}

export function getEmploymentStatuses() {
  return axios.get('employees/dicts/employment-statuses/')
}

export function getEmploymentTypes() {
  return axios.get('employees/dicts/employment-types/')
}

export function geIssuedEquipmentItems() {
  return axios.get('employees/dicts/issued-equipment-items/')
}

export function geRelationships() {
  return axios.get('employees/relationship/')
}

export function geEmployeesRace() {
  return axios.get('employees/race/')
}

export function geEmployeesMaritalStatus() {
  return axios.get('employees/marital-status/')
}

export function geEmployeesMedicalExaminationResult() {
  return axios.get('employees/dicts/medical-examination-results/')
}

export function geEmployeesLeaveTypes() {
  return axios.get('employees/dicts/leave-types/')
}

// ---------------------------------------------------- Employees: Employees
export function getEmployeesList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/employee/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getEmployeesListSearch(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/employee/search/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployee(data) {
  return axios.post('employees/employee/', data)
}

export function patchEmloyee(id, data) {
  return axios.patch(`employees/employee/${id}/`, data)
}

export function getEmployee(id) {
  return axios.get(`employees/employee/${id}/`)
}

// ---------------------------------------------------- Employees: Employees (Payroll)
export function getEmployeesPayrollList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/payroll/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getEmployeesPayrollDatesList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/payroll/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesPayroll(data) {
  return axios.post('employees/payroll/', data)
}

export function getEmployeesPayroll(id) {
  return axios.get(`employees/payroll/${id}/`)
}

export function getEmployeesPayrollEmployees(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/payroll/employees/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesPayrollRecalculate(id) {
  return axios.post(`employees/payroll/${id}/recalculate/`)
}

export function patchEmployeesPayrollControlInfo(payroll, data) {
  return axios.patch(`employees/payroll/payroll-control-info/${payroll}/`, data)
}

// ---------------------------------------------------- Employees: Employees (Driver allowance)
export function getEmployeesDriverAllowanceList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/driver-allowance/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesDriverAllowance(data) {
  return axios.post('employees/driver-allowance/', data)
}

export function getEmployeesDriverAllowance(id) {
  return axios.get(`employees/driver-allowance/${id}/`)
}

export function getEmployeesDriverAllowanceEmployeesList(id) {
  return axios.get(`employees/driver-allowance/${id}/employees/`)
}

export function patchEmployeesDriverAllowance(id, data) {
  return axios.patch(`employees/driver-allowance/${id}/`, data)
}

export function patchEmployeesDriverAllowanceEmployees(id, employee_id, data) {
  return axios.patch(`employees/driver-allowance/${id}/employees/${employee_id}/`, data)
}

// ---------------------------------------------------- Employees: Employees (Safari Driver allowance)
export function getEmployeesSafariDriverAllowanceList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/safari-driver-allowance/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesSafariDriverAllowance(data) {
  return axios.post('employees/safari-driver-allowance/', data)
}

export function getEmployeesSafariDriverAllowance(id) {
  return axios.get(`employees/safari-driver-allowance/${id}/`)
}

export function getEmployeesSafariDriverAllowanceEmployeesList(id) {
  return axios.get(`employees/safari-driver-allowance/${id}/employees/`)
}

export function patchEmployeesSafariDriverAllowance(id, data) {
  return axios.patch(`employees/safari-driver-allowance/${id}/`, data)
}

// ---------------------------------------------------- Employees: Employees (Sales allowance)
export function getEmployeesUTTAllowanceList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/utt/allowance/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesUTTAllowance() {
  return axios.post('employees/utt/allowance/')
}

export function getEmployeesUTTAllowance(id) {
  return axios.get(`employees/utt/allowance/${id}/`)
}

export function postEmployeesUTTAllowanceEmployees(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/utt/allowance/${id}/employees/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Employees: Employees (Advance Request)
export function getEmployeesAdvanceRequestsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/advance-requests/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesAdvanceRequest(data) {
  return axios.post('employees/advance-requests/', data)
}

// ---------------------------------------------------- Employees: Employees (Emergency contacts)
export function getEmployeesEmergencyContactList(id) {
  return axios.get(`employees/${id}/emergencycontact/`)
}

export function postEmployeesEmergencyContact(id, data) {
  return axios.post(`employees/${id}/emergencycontact/`, data)
}

export function patchEmployeesEmergencyContact(employee_id, id, data) {
  return axios.patch(`employees/${employee_id}/emergencycontact/${id}/`, data)
}

export function deleteEmployeesEmergencyContact(employee_id, id) {
  return axios.delete(`employees/${employee_id}/emergencycontact/${id}/`)
}

// ---------------------------------------------------- Employees: Employees (Warnings)
export function getEmployeesWarningList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/warnings/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesWarning(data) {
  return axios.post('employees/warnings/', data)
}

export function patchEmployeesWarning(id, data) {
  return axios.patch(`employees/warnings/${id}/`, data)
}

export function getEmployeesWarning(id) {
  return axios.get(`employees/warnings/${id}/`)
}

// ---------------------------------------------------- Employees: Employees (Benefits)
export function getEmployeesBenefitsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/benefits/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesBenefit(data) {
  return axios.post('employees/benefits/', data)
}

export function postEmployeesBenefitRequest(data) {
  return axios.post('employees/benefits/request/', data)
}

export function patchEmployeesBenefit(id, data) {
  return axios.patch(`employees/benefits/${id}/`, data)
}

export function getEmployeesBenefit(id) {
  return axios.get(`employees/benefits/${id}/`)
}

// ---------------------------------------------------- Employees: Employees (UTT Warnings)
export function getEmployeesUTTWarningsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/utt/warnings/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesUTTWarning(data) {
  return axios.post('employees/utt/warnings/', data)
}

export function patchEmployeesUTTWarning(id, data) {
  return axios.patch(`employees/utt/warnings/${id}/`, data)
}

// ---------------------------------------------------- Employees: Employees (UTT Benefits)
export function getEmployeesUTTBenefitsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/utt/benefits/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesUTTBenefit(data) {
  return axios.post('employees/utt/benefits/', data)
}

export function patchEmployeesUTTBenefit(id, data) {
  return axios.patch(`employees/utt/benefits/${id}/`, data)
}

// ---------------------------------------------------- Employees: Employees (Issued items)
export function getEmployeesIssueList(id) {
  return axios.get(`employees/${id}/issuedequipmentitems/`)
}

export function postEmployeesIssue(id, data) {
  return axios.post(`employees/${id}/issuedequipmentitems/`, data)
}

export function deleteEmployeesIssue(employee_id, id) {
  return axios.delete(`employees/${employee_id}/issuedequipmentitems/${id}/`)
}

// ---------------------------------------------------- Employees: Employees (Contracts)
export function getEmployeesContracts(id) {
  return axios.get(`employees/${id}/contracts/`)
}

export function postEmployeesContract(id, data) {
  return axios.post(`employees/${id}/contracts/`, data)
}

export function getAllEmployeesContracts(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/contracts/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAllEmployeesContract(data) {
  return axios.post('employees/contracts/', data)
}

export function patchAllEmployeesContract(id, data) {
  return axios.patch(`employees/contracts/${id}/`, data)
}

export function patchAllEmployeesContractRenewal(id, data) {
  return axios.patch(`employees/contracts/${id}/contract-renewal/`, data)
}

// ---------------------------------------------------- Employees: Employees (Salary)
export function getEmployeesSalaryList(id) {
  return axios.get(`employees/${id}/salary/`)
}

export function postEmployeesSalary(id, data) {
  return axios.post(`employees/${id}/salary/`, data)
}

export function patchEmployeesSalary(employee_id, id, data) {
  return axios.patch(`employees/${employee_id}/salary/${id}/`, data)
}

// ---------------------------------------------------- Employees: Employees (UTT Salary)
export function getEmployeesUTTSalaryList(id) {
  return axios.get(`employees/${id}/utt/salary/`)
}

export function postEmployeesUTTSalary(id, data) {
  return axios.post(`employees/${id}/utt/salary/`, data)
}

export function patchEmployeesUTTSalary(employee_id, id, data) {
  return axios.patch(`employees/${employee_id}/utt/salary/${id}/`, data)
}

// ---------------------------------------------------- Employees: Employees (Leaves)
export function getEmployeesLeavesCalendar(from, to) {
  return axios.get(`employees/leaves/calendar/?from_date=${from}&to_date=${to}`)
}

export function getEmployeesLeavesList(id) {
  return axios.get(`employees/${id}/leaves/`)
}

export function postEmployeesLeave(id, data) {
  return axios.post(`employees/${id}/leaves/`, data)
}

export function patchEmployeesLeave(employee_id, id, data) {
  return axios.patch(`employees/${employee_id}/leaves/${id}/`, data)
}

export function deleteEmployeesLeave(employee_id, id) {
  return axios.delete(`employees/${employee_id}/leaves/${id}/`)
}

// ---------------------------------------------------- Employees: Employees (Month Calculation)
export function getEmployeesMonthCalculation(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/${id}/month-calculation/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Employees: Employees (Employee family)
export function getEmployeesFamily(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/${id}/family/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesFamily(id, data) {
  return axios.post(`employees/${id}/family/`, data)
}

export function patchEmployeesFamily(id, inline_id, data) {
  return axios.patch(`employees/${id}/family/${inline_id}/`, data)
}

export function deleteEmployeesFamily(id, inline_id) {
  return axios.delete(`employees/${id}/family/${inline_id}/`)
}

// ---------------------------------------------------- Employees: Employees (Employee comment)
export function getEmployeesComments(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}employees/${id}/comments/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postEmployeesComment(id, data) {
  return axios.post(`employees/${id}/comments/`, data)
}

// ---------------------------------------------------- Employees: Employees (Employee medical examination)
export function getEmployeesMedicalExamination(id) {
  return axios.get(`employees/${id}/medical-examination/`)
}

export function postEmployeesMedicalExamination(id, data) {
  return axios.post(`employees/${id}/medical-examination/`, data)
}

export function patchEmployeesMedicalExamination(id, inline_id, data) {
  return axios.patch(`employees/${id}/medical-examination/${inline_id}/`, data)
}

export function deleteEmployeesMedicalExamination(id, inline_id) {
  return axios.delete(`employees/${id}/medical-examination/${inline_id}/`)
}

// ---------------------------------------------------- Administrative: Entities
export function getAdministrativeLegalEntities(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/legal-entities/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getAdministrativeLegalEntity(code) {
  return axios.get(`administrative/legal-entities/${code}/`)
}

// ---------------------------------------------------- Administrative: Cashflow
export function getAdministrativeSuppliersCashflow(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/suppliers/${id}/cashflow/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Administrative: Suppliers (Contact Person)
export function getAdministrativeSupplierContactPersons(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/suppliers/${id}/contact-persons/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAdministrativeSupplierContactPerson(id, data) {
  return axios.post(`administrative/suppliers/${id}/contact-persons/`, data)
}

export function patchAdministrativeSupplierContactPerson(suppliers_id, account_id, data) {
  return axios.patch(`administrative/suppliers/${suppliers_id}/contact-persons/${account_id}/`, data)
}

export function deleteAdministrativeSupplierContactPerson(suppliers_id, account_id) {
  return axios.delete(`administrative/suppliers/${suppliers_id}/contact-persons/${account_id}/`)
}

// ---------------------------------------------------- Administrative: Suppliers: Payment methods
export function getAdministrativeSuppliersPaymentMethods(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/suppliers/${id}/payment-methods/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAdministrativeSuppliersPaymentMethods(id, data) {
  return axios.post(`administrative/suppliers/${id}/payment-methods/`, data)
}

export function patchAdministrativeSuppliersPaymentMethods(id, pm_id, data) {
  return axios.patch(`administrative/suppliers/${id}/payment-methods/${pm_id}/`, data)
}

// ---------------------------------------------------- Administrative: Properties (Lease Agreements)
export function getAdministrativePropertiesLeaseAgreements(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/properties/${id}/lease-agreements/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAdministrativePropertiesLeaseAgreements(id, data) {
  return axios.post(`administrative/properties/${id}/lease-agreements/`, data)
}

export function patchAdministrativePropertiesLeaseAgreements(id, lease_id, data) {
  return axios.patch(`administrative/properties/${id}/lease-agreements/${lease_id}/`, data)
}

export function deleteAdministrativePropertiesLeaseAgreements(id, lease_id) {
  return axios.delete(`administrative/properties/${id}/lease-agreements/${lease_id}/`)
}

// ---------------------------------------------------- Administrative: Properties (Insurances)
export function getAdministrativePropertiesInsurances(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/properties/${id}/insurances/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAdministrativePropertiesInsurance(id, data) {
  return axios.post(`administrative/properties/${id}/insurances/`, data)
}

export function patchAdministrativePropertiesInsurance(id, insurance_id, data) {
  return axios.patch(`administrative/properties/${id}/insurances/${insurance_id}/`, data)
}

export function deleteAdministrativePropertiesInsurance(id, insurance_id) {
  return axios.delete(`administrative/properties/${id}/insurances/${insurance_id}/`)
}

// ---------------------------------------------------- Administrative: Properties
export function getAdministrativeProperties(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/properties/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAdministrativeProperties(data) {
  return axios.post('administrative/properties/', data)
}

export function getAdministrativeProperty(id) {
  return axios.get(`administrative/properties/${id}/`)
}

// let abortController = null

// ---------------------------------------------------- Administrative: Suppliers
export function getAdministrativeSuppliers(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/suppliers/search/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  // if (abortController) abortController.abort()
  // abortController = new AbortController()
  return axios.get(url)
}

export function getAdministrativeSupplierBankAccounts(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/suppliers/${id}/bank-accounts/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAdministrativeSupplierBankAccount(id, data) {
  return axios.post(`administrative/suppliers/${id}/bank-accounts/`, data)
}

export function patchAdministrativeSupplierBankAccount(suppliers_id, account_id, data) {
  return axios.patch(`administrative/suppliers/${suppliers_id}/bank-accounts/${account_id}/`, data)
}

export function deleteAdministrativeSupplierBankAccount(suppliers_id, account_id) {
  return axios.delete(`administrative/suppliers/${suppliers_id}/bank-accounts/${account_id}/`)
}

export function getAdministrativeSupplierMobileAccounts(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/suppliers/${id}/mobile-accounts/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAdministrativeSupplierMobileAccount(id, data) {
  return axios.post(`administrative/suppliers/${id}/mobile-accounts/`, data)
}

export function patchAdministrativeSupplierMobileAccount(suppliers_id, account_id, data) {
  return axios.patch(`administrative/suppliers/${suppliers_id}/mobile-accounts/${account_id}/`, data)
}

export function deleteAdministrativeSupplierMobileAccount(suppliers_id, account_id) {
  return axios.delete(`administrative/suppliers/${suppliers_id}/mobile-accounts/${account_id}/`)
}

export function getAdministrativeSupplierBankAccountSearch(suppliers_id) {
  return axios.get(`administrative/suppliers/accounts/banks/search/?supplier=${suppliers_id}`)
}

export function getAdministrativeSupplierMobileAccountSearch(suppliers_id) {
  return axios.get(`administrative/suppliers/accounts/mobile/search/?supplier=${suppliers_id}`)
}

// ---------------------------------------------------- Administrative: Suppliers (Full)
export function getAdministrativeSuppliersFullList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/suppliers/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postAdministrativeSupplierFull(data) {
  return axios.post('administrative/suppliers/', data)
}

export function getAdministrativeSupplierFull(id) {
  return axios.get(`administrative/suppliers/${id}/`)
}

export function patchAdministrativeSupplierFull(id, data) {
  return axios.patch(`administrative/suppliers/${id}/`, data)
}

export function getAdministrativeSupplierFullStats(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/suppliers/${id}/stats/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Administrative: Dicts
export function getAdministrativeLicenseGroups() {
  return axios.get('administrative/dicts/license/groups/')
}

export function getAdministrativeInsuranceGroups() {
  return axios.get('administrative/dicts/insurance/groups/')
}

export function getAdministrativeSuppliersGroups() {
  return axios.get('administrative/suppliers/groups/')
}

export function getAdministrativeSuppliersTypes() {
  return axios.get('administrative/dicts/suppliers/types/')
}

export function getAdministrativeBusinessUnits(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}administrative/business-units/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getAdministrativeLicenseTypes() {
  return axios.get('administrative/dicts/license/types/')
}

export function getAdministrativeInsuranceTypes() {
  return axios.get('administrative/dicts/insurance/types/')
}

// ---------------------------------------------------- Administrative: Export
export function getLandPurchaseContractExport(id) {
  return axios.get(`administrative/land-purchase-contract/${id}/export`, { responseType: 'blob' })
}

// ---------------------------------------------------- Product storage: Cash requests
export function getProductStorageCashRequests(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/cashrequest/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postProductStorageCashRequests(data) {
  return axios.post('productstorage/cashrequest/', data)
}

export function getProductStorageCashRequestDetail(id) {
  return axios.get(`productstorage/cashrequest/${id}/`)
}

export function patchProductStorageCashRequest(id, data) {
  return axios.patch(`productstorage/cashrequest/${id}/`, data)
}

export function deleteProductStorageCashRequest(id) {
  return axios.delete(`productstorage/cashrequest/${id}/`)
}

export function deleteProductStorageCashRequestOrder(id, order_id) {
  return axios.delete(`productstorage/cashrequest/${id}/order/${order_id}/`)
}

// ---------------------------------------------------- Product storage: Products (History)
export function getProductStorageProductBalanceHistory(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/product/${id}/balance/history/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getProductStorageProductPriceHistory(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/product/${id}/price/history/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Product storage: Transfers
export function getProductStorageTransfers(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/transfers/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postProductStorageTransfer(data) {
  return axios.post('productstorage/transfers/', data)
}

export function getProductStorageTransfer(id) {
  return axios.get(`productstorage/transfers/${id}/`)
}

export function deleteProductStorageTransfer(id) {
  return axios.delete(`productstorage/transfers/${id}/`)
}

export function patchProductStorageTransfer(id, data) {
  return axios.patch(`productstorage/transfers/${id}/`, data)
}

// ---------------------------------------------------- Product storage: Exports
export function getSupplierExport() {
  return axios.get('productstorage/suppliers/export/', { responseType: 'blob' })
}

export function getProductsExport() {
  return axios.get('productstorage/products/export/', { responseType: 'blob' })
}

export function getTransferPrint(id) {
  return axios.get(`productstorage/transfer/${id}/export/`)
}

export function getStocktakingPrint(id) {
  return axios.get(`productstorage/stocktaking/${id}/export/`)
}

export function getCashRequestPrint(id) {
  return axios.get(`productstorage/cashrequest/${id}/export/`)
}

export function getOrderPrint(id) {
  return axios.get(`productstorage/order/${id}/export/`)
}

// ---------------------------------------------------- Product storage: Analytics export
export function getProductStorageTransferAnalyticsExport(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/analytics/transfers/export/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url, { responseType: 'blob' })
}

// ---------------------------------------------------- Product storage: Dicts
export function getProductcategory() {
  return axios.get('productstorage/productcategory/')
}

export function geMeasurements() {
  return axios.get('productstorage/measurement/')
}

export function getProductStorageResponsibleCenter() {
  return axios.get('productstorage/responsible-center/')
}

export function getProductStorageTransportType() {
  return axios.get('productstorage/transporttype/')
}

// ---------------------------------------------------- Product storage: Suppliers (Payments)
export function getSupplierPayments(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/supplier/${id}/payments/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postSupplierPayments(id, data) {
  return axios.post(`productstorage/supplier/${id}/payments/`, data)
}

// ---------------------------------------------------- Product storage: Suppliers
export function getSuppliersProduct(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/supplier/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postSupplierProduct(data) {
  return axios.post('productstorage/supplier/', data)
}

export function getSupplierProduct(id) {
  return axios.get(`productstorage/supplier/${id}/`)
}

export function patchProductStorageSupplier(id, data) {
  return axios.patch(`productstorage/supplier/${id}/`, data)
}

// ---------------------------------------------------- Product storage: Products
export function getProductsProductstorage(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/product/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postProductStorageProduct(data) {
  return axios.post('productstorage/product/', data)
}

export function getProductStorageProduct(id) {
  return axios.get(`productstorage/product/${id}/`)
}

export function patchProductStorageProduct(id, data) {
  return axios.patch(`productstorage/product/${id}/`, data)
}

// ---------------------------------------------------- Product storage: Orders
export function getOrdersProduct(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/orders/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postProductStorageOrder(data) {
  return axios.post('productstorage/orders/', data)
}

export function getProductStorageOrder(id) {
  return axios.get(`productstorage/orders/${id}/`)
}

export function deleteProductStorageOrder(id) {
  return axios.delete(`productstorage/orders/${id}/`)
}

export function patchProductStorageOrder(id, data) {
  return axios.patch(`productstorage/orders/${id}/`, data)
}

// ---------------------------------------------------- Product storage: Stocktaking
export function getProductStorageStocktaking(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/stocktaking/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postProductStorageStocktaking(data) {
  return axios.post('productstorage/stocktaking/', data)
}

export function getProductStorageStocktakingDetail(id) {
  return axios.get(`productstorage/stocktaking/${id}/`)
}

export function patchProductStorageStocktaking(id, data) {
  return axios.patch(`productstorage/stocktaking/${id}/`, data)
}

export function deleteProductStorageStocktaking(id) {
  return axios.delete(`productstorage/stocktaking/${id}/`)
}

// ---------------------------------------------------- Product storage: Stocktaking (Products list) product
export function getProductStorageStocktakingProducts(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/${id}/stocktaking_products/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchProductStorageStocktakingProduct(id, product_id, data) {
  return axios.patch(`productstorage/${id}/stocktaking_products/${product_id}/`, data)
}

// ---------------------------------------------------- Product storage: Orders (Products list)
export function getProductstorageOrderProduct(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/${id}/order_products/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchProductstorageOrderProduct(order_id, product_id, data) {
  return axios.patch(`productstorage/${order_id}/order_products/${product_id}/`, data)
}

export function postProductstorageOrderProduct(order_id, data) {
  return axios.post(`productstorage/${order_id}/order_products/`, data)
}

export function deleteProductstorageOrderProduct(order_id, product_id) {
  return axios.delete(`productstorage/${order_id}/order_products/${product_id}/`)
}

// ---------------------------------------------------- Product storage: Transfer (Products list)
export function getProductStorageTransferProductList(id) {
  return axios.get(`productstorage/${id}/transfer_products/`)
}

export function patchProductStorageTransferProduct(transfer_id, product_id, data) {
  return axios.patch(`productstorage/${transfer_id}/transfer_products/${product_id}/`, data)
}

export function postProductstorageTransferProduct(transfer_id, data) {
  return axios.post(`productstorage/${transfer_id}/transfer_products/`, data)
}

export function deleteProductstorageTransferProduct(transfer_id, product_id) {
  return axios.delete(`productstorage/${transfer_id}/transfer_products/${product_id}/`)
}

// ---------------------------------------------------- Product storage: Analytics
export function getProductStorageTransfersAnalytics(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/analytics/transfers/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getProductStorageOrdersAnalytics(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}productstorage/analytics/orders/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getProductStorageGeneralProductsAnalytics() {
  return axios.get('productstorage/analytics/main/products/')
}

export function getProductStorageGeneralSuppliersAnalytics() {
  return axios.get('productstorage/analytics/main/suppliers/')
}

export function getProductStorageGeneralPricesAnalytics(after, before) {
  return axios.get(`productstorage/analytics/main/products_price/?date_range_after=${after}&date_range_before=${before}`)
}

// ---------------------------------------------------- Car management: Dicts
export function getCarManagementCarModels() {
  return axios.get('carmanagement/car-models/')
}

export function getCarManagementServicePriorityClasses() {
  return axios.get('carmanagement/service-priority-classes/')
}

// ---------------------------------------------------- Car management: Cars
export function getCarManagementCars(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}carmanagement/cars/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getCarManagementCarsDetail(id) {
  return axios.get(`carmanagement/cars/${id}/`)
}

export function patchCarManagementCar(id, data) {
  return axios.patch(`carmanagement/cars/${id}/`, data)
}

export function getCarManagementCarsSelect() {
  return axios.get('carmanagement/cars/select/')
}

// ---------------------------------------------------- Car management: Fuel vendors
export function getCarManagementVendors(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}carmanagement/vendors/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchCarManagementVendors(id, data) {
  return axios.patch(`carmanagement/vendors/${id}/`, data)
}

// ---------------------------------------------------- Car management: Cars (Licenses)
export function getCarManagementCarsLicenses(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}carmanagement/cars/${id}/licenses/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postCarManagementCarsLicense(id, data) {
  return axios.post(`carmanagement/cars/${id}/licenses/`, data)
}

export function patchCarManagementCarsLicense(id, license_id, data) {
  return axios.patch(`carmanagement/cars/${id}/licenses/${license_id}/`, data)
}

export function deleteCarManagementCarsLicense(id, license_id) {
  return axios.delete(`carmanagement/cars/${id}/licenses/${license_id}/`)
}

// ---------------------------------------------------- Car management: Cars (Insurance)
export function getCarManagementCarsInsurances(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}carmanagement/cars/${id}/insurances/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postCarManagementCarsInsurance(id, data) {
  return axios.post(`carmanagement/cars/${id}/insurances/`, data)
}

export function patchCarManagementCarsInsurance(id, insurance_id, data) {
  return axios.patch(`carmanagement/cars/${id}/insurances/${insurance_id}/`, data)
}

export function deleteCarManagementCarsInsurance(id, insurance_id) {
  return axios.delete(`carmanagement/cars/${id}/insurances/${insurance_id}/`)
}

// ---------------------------------------------------- Car management: Logs
export function getCarManagementFuelLogs(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}carmanagement/fuel-logs/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchCarManagementFuelLog(id, data) {
  return axios.patch(`carmanagement/fuel-logs/${id}/`, data)
}

export function deleteCarManagementFuelLog(id) {
  return axios.delete(`carmanagement/fuel-logs/${id}/`)
}

export function getCarManagementFuelLogsGraph(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}carmanagement/fuel-logs/graph/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchCarManagementFuelLogEfdReceipts(id, data) {
  return axios.patch(`carmanagement/fuel-logs/${id}/efd-receipts/`, data)
}

export function patchCarManagementFuelLogVerify(id, data) {
  return axios.patch(`carmanagement/fuel-logs/${id}/verify/`, data)
}

export function postCarManagementFuelLogsRefresh() {
  return axios.post('carmanagement/fuel-logs/refresh/')
}

// ---------------------------------------------------- Domestic flights: Dicts
export function getDomesticFlightsAirlines() {
  return axios.get('domestic-flights/dicts/airlines/')
}

// ---------------------------------------------------- Domestic flights: Schedules
export function getDomesticFlightsSchedulesOriginAvailable(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}domestic-flights/schedules/origin_available/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getDomesticFlightsSchedulesDestinationAvailable(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}domestic-flights/schedules/destination_available/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getDomesticFlightsSchedulesAirlinesAvailable(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}domestic-flights/schedules/airlines_available/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getDomesticFlightsSchedulesScheduleSelection(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}domestic-flights/schedules/schedule_selection/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Domestic flights: Airline
export function getDomesticFlightsAirlinesList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}domestic-flights/airlines/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getDomesticFlightsAirlinesDetail(id) {
  return axios.get(`domestic-flights/airlines/${id}/`)
}

export function patchDomesticFlightsAirlinesDetail(id, data) {
  return axios.patch(`domestic-flights/airlines/${id}/`, data)
}

// ---------------------------------------------------- Domestic flights: Airline: Emails
export function postDomesticFlightsAirlinesEmails(id, data) {
  return axios.post(`domestic-flights/airlines/${id}/emails/`, data)
}

export function getDomesticFlightsAirlinesEmails(id) {
  return axios.get(`domestic-flights/airlines/${id}/emails/`)
}

export function deleteDomesticFlightsAirlinesEmails(id, email_id) {
  return axios.delete(`domestic-flights/airlines/${id}/emails/${email_id}/`)
}

// ---------------------------------------------------- Daytrips: Dicts
export function getDayTripsActivity() {
  return axios.get('daytrips/activity/')
}

// ---------------------------------------------------- Daytrips: Daytrips
export function getDayTripsDayTrips(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}daytrips/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getDayTripsDayTripsByDated(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}daytrips/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getDayTripsDayTrip(id) {
  return axios.get(`daytrips/${id}/`)
}

export function getDayTripsDayTripClients(id) {
  return axios.get(`daytrips/daytrips/${id}/clients/`)
}

export function postDayTripsDayTrip(data) {
  return axios.post('daytrips/', data)
}

export function patchDayTripsDayTrip(id, data) {
  return axios.patch(`daytrips/${id}/`, data)
}

export function postDayTripsDayTripAddClient(id, data) {
  return axios.post(`daytrips/daytrip/${id}/add-client/`, data)
}

// ---------------------------------------------------- Reservations: Hotels
export function postReservationsHotelsStoryImport(data) {
  return axios.post('reservations/hotels/story-import/', data)
}

export function postReservationsHotelsStoryCreate(data) {
  return axios.post('reservations/hotels/story-reservation-create/', data)
}

export function getReservationsHotelsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/hotels/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postReservationsHotelsCreate(data) {
  return axios.post('reservations/hotels/', data)
}

export function getReservationsHotelsClients(client_group_id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/hotels/${client_group_id}/clients/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsHotel(id) {
  return axios.get(`reservations/hotels/${id}/`)
}

export function patchReservationsHotel(id, data) {
  return axios.patch(`reservations/hotels/${id}/`, data)
}

export function getReservationsHotelsCheck(id) {
  return axios.get(`reservations/hotels/${id}/check/`)
}

export function getReservationsHotelsGuests(id) {
  return axios.get(`reservations/hotels/${id}/guests/`)
}

export function deleteReservationsHotel(id) {
  return axios.delete(`reservations/hotels/${id}/`)
}

export function getReservationsHotelsTermsPaymentPlan(id) {
  return axios.get(`reservations/hotels/${id}/terms-payment-plan/`)
}

export function postReservationsHotelsTermsPaymentPlan(id, data) {
  return axios.post(`reservations/hotels/${id}/terms-payment-plan/`, data)
}

// ---------------------------------------------------- Reservations: Dicts
export function getReservationsSalesStatuses(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/reservation-sales-statuses/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsEmailTypes() {
  return axios.get('reservations/email-type/')
}

export function getReservationsCancellationRequestStatuses(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/cancellation-request-status/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsAmendmentRequestStatuses(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/amendment-request-statuses/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsMealType() {
  return axios.get('reservations/meal-type/')
}

export function getReservationsItineraryTypes() {
  return axios.get('reservations/itinerary-types/')
}

export function getReservationsItineraryTimingTemplates(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/itinerary-timing-templates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Reservations: Export
export function getReservationsHotelsExportAbnormalPrice() {
  return axios.get('reservations/hotels/export/abnormal-price-filter/', { responseType: 'blob' })
}

// ---------------------------------------------------- Reservation: Payments
export function postReservationsHotelsPaymentPlan(id, data) {
  return axios.post(`reservations/hotels/${id}/payment-plan/`, data)
}

export function deleteReservationsHotelsPaymentPlan(id, payment_id) {
  return axios.delete(`reservations/hotels/${id}/payment-plan/${payment_id}/`)
}

export function getReservationsPaymentPlanHotels(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/payment-plan/hotels/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsPaymentPlanFlight(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/payment-plan/flight/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsPaymentPlanMeals(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/payment-plan/meals/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Reservations: Invoices
export function postReservationsHotelsInvoice(id, data) {
  return axios.post(`reservations/hotels/${id}/invoice/`, data)
}

export function patchReservationsHotelsInvoice(id, invoice_id, data) {
  return axios.patch(`reservations/hotels/${id}/invoice/${invoice_id}/`, data)
}

// ---------------------------------------------------- Reservations: Hotel Meals
export function postReservationsHotelsMeal(id, data) {
  return axios.post(`reservations/hotels/${id}/meal/`, data)
}

export function patchReservationsHotelsMeal(id, meal_box_id, data) {
  return axios.patch(`reservations/hotels/${id}/meal/${meal_box_id}/`, data)
}

// ---------------------------------------------------- Reservations: Abnormal price verification
export function patchReservationsHotelsAbnormalPriceVerification(id, data) {
  return axios.patch(`reservations/hotels/${id}/abnormal-price-verification/`, data)
}

// ---------------------------------------------------- Hotels: Dicts
export function getHotelsAccomodationTypes() {
  return axios.get('hotels/accomodation-types/')
}

export function getHotelsMealPlanTypes() {
  return axios.get('hotels/meal-plan-type/')
}

export function getHotelsChain() {
  return axios.get('hotels/hotel-chain/')
}

// ---------------------------------------------------- Hotels: Hotel Emails
export function postHotelsEmails(id, data) {
  return axios.post(`hotels/${id}/emails/`, data)
}

export function getHotelsEmails(id) {
  return axios.get(`hotels/${id}/emails/`)
}

export function postHotelsImport() {
  return axios.post('hotels/hotels_import/')
}

export function deleteHotelsEmails(id, email_id) {
  return axios.delete(`hotels/${id}/emails/${email_id}/`)
}

// ---------------------------------------------------- Hotels: Hotel
export function getHotelsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotels/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getHotelsListSearch(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotels/search/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postHotelsMap(params) {
  return axios.post('hotels/map/', params)
}

export function getHotelsRooms(id) {
  return axios.get(`hotels/${id}/rooms/`)
}

export function postHotelsPriceCheck(data) {
  return axios.post('hotels/price-check/', data)
}

export function postHotelsSelection(data) {
  return axios.post('hotels/selection/', data)
}

export function getHotelDetail(id) {
  return axios.get(`hotels/${id}/`)
}

export function patchHotelDetail(id, data) {
  return axios.patch(`hotels/${id}/`, data)
}

// ---------------------------------------------------- Reservations: Hotels cancellation request
export function getReservationsHotelsCancellationRequests(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/hotel-cancellation-request/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchReservationsHotelsCancellationRequest(id, data) {
  return axios.patch(`reservations/hotel-cancellation-request/${id}/`, data)
}

export function postReservationsHotelsCancellationRequest(data) {
  return axios.post('reservations/hotel-cancellation-request/', data)
}

// ---------------------------------------------------- Reservations: Hotels cancellation request
export function postReservationsHotelRooms(id, data) {
  return axios.post(`reservations/hotels/${id}/rooms/`, data)
}

// ---------------------------------------------------- Reservations: Hotels meal requests
export function postReservationsHotelMealRequests(id, data) {
  return axios.post(`reservations/hotels/${id}/meal-requests/`, data)
}

// ---------------------------------------------------- Reservations: Hotel alternative option
export function getReservationsHotelsAlternativeOptions(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/hotels/${id}/hotel-alternative-option/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postReservationsHotelsAlternativeOption(id, data) {
  return axios.post(`reservations/hotels/${id}/hotel-alternative-option/`, data)
}

export function deleteReservationsHotelsAlternativeOption(id, option_id) {
  return axios.delete(`reservations/hotels/${id}/hotel-alternative-option/${option_id}/`)
}

// ---------------------------------------------------- Reservations: Logs
export function getReservationsHotelReservationStatusLogs(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/hotels/${id}/reservation-status-logs/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsHotelSalesStatusLogs(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/hotels/${id}/sales-status-logs/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Reservations: Hotels meals
export function patchReservationsHotelMeal(id, meal_id, data) {
  return axios.patch(`reservations/hotels/${id}/meal/${meal_id}/`, data)
}

// ---------------------------------------------------- Reservations: Amendment request (Hotels)
export function getReservationsHotelAmendmentRequests(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/hotel-amendment-request/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postReservationsHotelAmendmentRequest(data) {
  return axios.post('reservations/hotel-amendment-request/', data)
}

export function patchReservationsHotelAmendmentRequest(id, data) {
  return axios.patch(`reservations/hotel-amendment-request/${id}/`, data)
}

// ---------------------------------------------------- Reservations: Flights
export function getReservationsFlightsClients(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/flights/${id}/clients/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsFlights(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/flights/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsFlight(id) {
  return axios.get(`reservations/flights/${id}/`)
}

export function postReservationsFlights(data) {
  return axios.post('reservations/flights/', data)
}

export function patchReservationsFlights(id, data) {
  return axios.patch(`reservations/flights/${id}/`, data)
}

export function deleteReservationsFlights(id) {
  return axios.delete(`reservations/flights/${id}/`)
}

// ---------------------------------------------------- Reservations: Flights cancellation request
export function getReservationsFlightCancellationRequest(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/flight-cancellation-request/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postReservationsFlightCancellationRequest(data) {
  return axios.post('reservations/flight-cancellation-request/', data)
}

export function patchReservationsFlightCancellationRequest(id, data) {
  return axios.patch(`reservations/flight-cancellation-request/${id}/`, data)
}

// ---------------------------------------------------- Reservations: Flights amendment request
export function getReservationsFlightAmendmentRequest(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/flight-amendment-request/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postReservationsFlightAmendmentRequest(data) {
  return axios.post('reservations/flight-amendment-request/', data)
}

export function patchReservationsFlightAmendmentRequest(id, data) {
  return axios.patch(`reservations/flight-amendment-request/${id}/`, data)
}

// ---------------------------------------------------- Reservations: Flights: Invoices
export function postReservationsFlightsInvoice(id, data) {
  return axios.post(`reservations/flights/${id}/invoice/`, data)
}

export function patchReservationsFlightsInvoice(id, invoice_id, data) {
  return axios.patch(`reservations/flights/${id}/invoice/${invoice_id}/`, data)
}

// ---------------------------------------------------- Reservations: Emails
export function getReservationsEmails(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/emails/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postReservationsHotelsEmail(id, data) {
  return axios.post(`reservations/hotels/${id}/email/`, data)
}

export function postReservationsFlightsEmail(id, data) {
  return axios.post(`reservations/flights/${id}/email/`, data)
}

export function postReservationsHotelsEmailExtendProvisional(id, data) {
  return axios.post(`reservations/hotels/${id}/email-extend-provisional/`, data)
}

export function postReservationsHotelsCancellationRequestsEmail(id, data) {
  return axios.post(`reservations/hotel-cancellation-requests/${id}/email/`, data)
}

export function postReservationsHotelsAmendmentRequestsEmail(id, data) {
  return axios.post(`reservations/hotel-amendment-requests/${id}/email/`, data)
}

export function postReservationsFlightsCancellationRequestsEmail(id, data) {
  return axios.post(`reservations/flight-cancellation-requests/${id}/email/`, data)
}

export function postReservationsFlightsAmendmentRequestsEmail(id, data) {
  return axios.post(`reservations/flight-amendment-requests/${id}/email/`, data)
}

// ---------------------------------------------------- Reservations: Email template
export function getReservationsEmailTemplate(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/email-template/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Reservations: Payment Requests
export function getReservationsPaymentRequestsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/payment-requests/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsPaymentRequest(id) {
  return axios.get(`reservations/payment-requests/${id}/`)
}

export function postReservationsPaymentRequest(data) {
  return axios.post('reservations/payment-requests/', data)
}

export function patchReservationsPaymentRequest(id, data) {
  return axios.patch(`reservations/payment-requests/${id}/`, data)
}

export function deleteReservationsPaymentRequestPaymentPlans(id, payment_plan_id) {
  return axios.delete(`reservations/payment-requests/${id}/payment-plans/${payment_plan_id}/`)
}

// ---------------------------------------------------- Reservations: Safari
export function getReservationsSafariOwnCars(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/safari/own-cars/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsSafariRentalCars(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/safari/rental-cars/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postReservationsSafariDriverSchedule(data) {
  return axios.post('reservations/safari/driver-schedule/', data)
}

export function getReservationsSafariItineraries(id) {
  return axios.get(`reservations/safari/${id}/driver-itineraries/`)
}

export function patchReservationsSafariItineraries(id, data) {
  return axios.patch(`reservations/safari/${id}/driver-itineraries/timing/`, data)
}

// ---------------------------------------------------- Reservations: Schedule
export function getReservationsSafariScheduleCalendar(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/safari/schedule/calendar/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Reservation: Safari
export function getReservationsSafari(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/safari/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postReservationsSafari(data) {
  return axios.post('reservations/safari/', data)
}

export function getReservationSafari(id) {
  return axios.get(`reservations/safari/${id}/`)
}

export function patchReservationSafari(id, data) {
  return axios.patch(`reservations/safari/${id}/`, data)
}

export function postReservationsSafariStoryImport(data) {
  return axios.post('reservations/safari/story-import/', data)
}

export function getReservationsSafariCars(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/safari/cars/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationSafariCars(id) {
  return axios.get(`reservations/safari/${id}/cars/`)
}

export function patchReservationSafariCars(id, data) {
  return axios.patch(`reservations/safari/${id}/cars/`, data)
}

export function postReservationSafariAmendmentRequest(data) {
  return axios.post('reservations/safari-amendment-request/', data)
}

// ---------------------------------------------------- Reservations: Meals
export function getReservationsMeals(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}reservations/meal/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getReservationsMeal(id) {
  return axios.get(`reservations/meal/${id}/`)
}

export function postReservationsMeal(data) {
  return axios.post('reservations/meal/', data)
}

export function patchReservationsMeal(id, data) {
  return axios.patch(`reservations/meal/${id}/`, data)
}

export function getReservationsMealGuest(id) {
  return axios.get(`reservations/meal/${id}/guests/`)
}

// ---------------------------------------------------- Car management: Cars (History)
export function getCarManagementOdometerHistory(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}carmanagement/cars/${id}/history/odometer/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Hotel Management: Dicts
export function getHotelManagementProperties(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/properties/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getHotelManagementRoomTypeGroups(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/room-type-groups/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getHotelManagementReservationStatus(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/reservation-status/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Hotel Management: Reservations
export function getHotelManagementReservationsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/reservations/dates/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getHotelManagementReservation(id) {
  return axios.get(`hotel_management/reservations/${id}/`)
}

export function patchHotelManagementReservation(id, data) {
  return axios.patch(`hotel_management/reservations/${id}/`, data)
}

export function postHotelManagementReservationSync() {
  return axios.post('hotel_management/reservations/sync/')
}

export function postHotelManagementReservationDetailSync(id) {
  return axios.post(`hotel_management/reservations/${id}/sync/`)
}

export function getHotelManagementReservationsSubreservationsList(id, params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/reservations/${id}/sub-reservations/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Hotel Management: House Accounts
export function getHotelManagementHouseAccountsList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/house-accounts/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getHotelManagementHouseAccount(id) {
  return axios.get(`hotel_management/house-accounts/${id}/`)
}

export function patchHotelManagementHouseAccount(id, data) {
  return axios.patch(`hotel_management/house-accounts/${id}/`, data)
}

// ---------------------------------------------------- Reservations: Meal: Invoices
export function postReservationsMealInvoice(id, data) {
  return axios.post(`reservations/meal/${id}/invoice/`, data)
}

export function patchReservationsMealInvoice(id, invoice_id, data) {
  return axios.patch(`reservations/meal/${id}/invoice/${invoice_id}/`, data)
}

// ---------------------------------------------------- Hotel Management: Transactions
export function getHotelManagementTransactionList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/transactions/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchHotelManagementTransaction(transaction, data) {
  return axios.patch(`hotel_management/transactions-cash/${transaction}/`, data)
}

export function postHotelManagementTransactionEFD(transaction, data) {
  return axios.post(`hotel_management/transactions/${transaction}/efd/`, data)
}

// ---------------------------------------------------- Hotel Management: Balance History
export function getHotelManagementBalanceHistoryList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/balance-history/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getHotelManagementBalanceHistoryDetail(id) {
  return axios.get(`hotel_management/balance-history/${id}/`)
}

// ---------------------------------------------------- Hotel Management: Invoices
export function getHotelManagementInvoice(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/invoice/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postHotelManagementInvoicesCreate(data) {
  return axios.post('hotel_management/invoice/create/', data)
}

// ---------------------------------------------------- Hotel Management: Cashflow
export function getHotelManagementCashflow(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/cashflow/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postHotelManagementCashflowTransferToOffice(data) {
  return axios.post('hotel_management/cashflow/transfer-to-office/', data)
}

// ---------------------------------------------------- Hotel Management: Shop Stocktaking
export function getHotelManagementShopStocktakingList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}hotel_management/shop-stocktaking/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postHotelManagementShopStocktaking() {
  return axios.post('hotel_management/shop-stocktaking/')
}

export function getHotelManagementShopStocktaking(id) {
  return axios.get(`hotel_management/shop-stocktaking/${id}/`)
}

export function patchHotelManagementShopStocktaking(id, data) {
  return axios.patch(`hotel_management/shop-stocktaking/${id}/`, data)
}

export function deleteHotelManagementShopStocktaking(id) {
  return axios.delete(`hotel_management/shop-stocktaking/${id}/`)
}

export function getHotelManagementShopStocktakingExport(id) {
  return axios.get(`hotel_management/shop-stocktaking/${id}/export/`)
}

// ---------------------------------------------------- Hotel Management: Balance History
export function postHotelManagementBalanceHistory(data) {
  return axios.post('hotel_management/balance-history/', data)
}

// ---------------------------------------------------- Users
export function getMe() {
  return axios.get('users/me/')
}

export function getUsers(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}users/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postUsers(params) {
  return axios.post('users/', params)
}

export function patchUsers(id, params) {
  return axios.patch(`users/${id}/`, params)
}

export function getUsersGroups() {
  return axios.get('users/groups/')
}

// ---------------------------------------------------- Dicts
export function getRaces() {
  return axios.get('dicts/race/')
}

export function getMaritalStatuses() {
  return axios.get('dicts/marital-status/')
}

export function getLanguages(content_available = '') {
  return axios.get(`dicts/languages/?content_available=${content_available}`)
}

export function getGenders() {
  return axios.get('dicts/genders/')
}

export function getCountries() {
  return axios.get('dicts/countries/')
}

export function getResidences() {
  return axios.get('dicts/residences/')
}

export function getCovidVaccines() {
  return axios.get('dicts/covid-vaccines/?active=true')
}

export function getFoodPreferences() {
  return axios.get('dicts/food-preferences/')
}

export function getArrivalMethods() {
  return axios.get('dicts/arrival-departure-methods/')
}

export function getArrivalCompanies(type = '', search = '') {
  return axios.get(`dicts/arrival-departure-companies/?type=${type}&search=${search}`)
}

export function getPaymentMethods() {
  return axios.get('dicts/paymentmethod/')
}

export function getBanks() {
  return axios.get('dicts/bank/')
}

export function getPeopleCategories() {
  return axios.get('dicts/people-categories/')
}

export function getColors() {
  return axios.get('dicts/colors/?active=true')
}

export function getCalculationMethods() {
  return axios.get('dicts/calculation-methods/')
}

export function getCountryGroups() {
  return axios.get('dicts/country-groups/')
}

export function getWFRVendor() {
  return axios.get('dicts/wfr-vendor/')
}

export function getLocationAreas(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}dicts/location-areas/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getLocationRegions(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}dicts/location-regions/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getLocationVillages(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}dicts/location-village/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getLocationTerritories() {
  return axios.get('dicts/location-territories/')
}

export function getDictRelationships(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}dicts/relationship/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getDisability() {
  return axios.get('dicts/disability/')
}

export function getEducationLevels() {
  return axios.get('dicts/education-levels/')
}

export function getDeviceTypes() {
  return axios.get('dicts/device-types/')
}

// ---------------------------------------------------- Dicts: Locations
export function getLocations(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}dicts/locations/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postLocation(data) {
  return axios.post('dicts/locations/', data)
}

export function patchLocation(id, data) {
  return axios.patch(`dicts/locations/${id}/`, data)
}

export function getLocationTypes() {
  return axios.get('dicts/location-types/')
}

// ---------------------------------------------------- QRService
export function getQRServices(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}common/qr-code/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postQRService(data) {
  return axios.post('common/qr-code/', data)
}

// ---------------------------------------------------- Common: Advertising Requests
export function getCommonAdvertisingRequests(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}common/advertising-requests/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Leads: Trengo
export function getLeadsTrengoTickets(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/trengo-tickets/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getLeadsTrengoTicket(id) {
  return axios.get(`leads/trengo-tickets/${id}/`)
}

export function getLeadsTrengoWAWebhooks(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}leads/trengo/wa-webhooks/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function patchLeadsTrengoTicket(id, data) {
  return axios.patch(`leads/trengo-tickets/${id}/`, data)
}

// ---------------------------------------------------- Integrations
export function getGoogleSearch(search) {
  return axios.get(`googlemaps/search/?Search=${search}`)
}

// ---------------------------------------------------- Currency
export function getCurrencyList(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}currency/currencies/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postCurrencyCalculator(data) {
  return axios.post('currency/exchangerates/calculator/', data)
}

// ---------------------------------------------------- Storage: Dicts
export function getStorageDictsSections(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/dicts/sections/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageDictsCategories(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/dicts/categories/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageDictsMeasurements(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/dicts/measurements/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageDictsBrand(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/dicts/brands/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

// ---------------------------------------------------- Storage: Items
export function getStorageItemsBulkClimbingEquipment(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/bulk/climbing-equipment/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageItemsTrackableClimbingEquipment(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/trackable/climbing-equipment/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageItemsBulkKitchenEquipment(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/bulk/kitchen-equipment/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageItemsBulkMedications(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/bulk/medications/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageItemsBulkMedicalEquipment(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/bulk/medical-equipment/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageItemsBulkGas(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/bulk/gas/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageItemsTrackableClimbingElectronics(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/trackable/climbing-electronics/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageItemsTrackableOxygen(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/trackable/oxygen/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function getStorageItems(params) {
  const url = new URL(`${process.env.VUE_APP_API_URL}storage/items/`)

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value || value === false) url.searchParams.append(key, value)
    })
  }
  return axios.get(url)
}

export function postStorageItems(data) {
  return axios.post('storage/items/', data)
}

export function patchStorageItems(id, data) {
  return axios.patch(`storage/items/${id}/`, data)
}

export function postStorageItemsTrackable(data) {
  return axios.post('storage/items/trackable/', data)
}

// ---------------------------------------------------- Files
export function postFile(data) {
  return axios.post('files/', data)
}

export function postFileBase64(data) {
  return axios.post('files/images/base64/', data)
}

// ---------------------------------------------------- Authentication
export function postTOTPCreate() {
  return axios.post('auth/totp/create/')
}

export function postTOTPVerify(token) {
  return axios.post(`auth/totp/verify/${token}/`)
}
